import React from "react";

export default class AsmgcsSvg extends React.PureComponent {
  render() {
    return (
      <svg
        className="hia-svg"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        x="0px"
        y="0px"
        viewBox="0 0 664.9 298.6"
      >
        <defs>
          <linearGradient
            id="a"
            x1="-884.066%"
            x2="169.299%"
            y1="50.1%"
            y2="50.1%"
          >
            <stop offset="0%" stopColor="#131426" />
            <stop offset="100%" stopColor="#24275D" />
          </linearGradient>
          <linearGradient
            id="b"
            x1=".166%"
            x2="120.908%"
            y1="49.838%"
            y2="49.838%"
          >
            <stop offset="0%" stopColor="#131426" />
            <stop offset="100%" stopColor="#24275D" />
          </linearGradient>
          <linearGradient
            id="c"
            x1="-682.42%"
            x2="104.889%"
            y1="50.132%"
            y2="50.132%"
          >
            <stop offset="0%" stopColor="#131426" />
            <stop offset="100%" stopColor="#24275D" />
          </linearGradient>
          <linearGradient
            id="d"
            x1="-682.42%"
            x2="104.889%"
            y1="49.739%"
            y2="49.739%"
          >
            <stop offset="0%" stopColor="#131426" />
            <stop offset="100%" stopColor="#24275D" />
          </linearGradient>
          <linearGradient
            id="e"
            x1="-883.376%"
            x2="169.989%"
            y1="48.432%"
            y2="48.432%"
          >
            <stop offset="0%" stopColor="#131426" />
            <stop offset="100%" stopColor="#24275D" />
          </linearGradient>
          <linearGradient
            id="f"
            x1="-2507.486%"
            x2="429.776%"
            y1="52.06%"
            y2="52.06%"
          >
            <stop offset="0%" stopColor="#131426" />
            <stop offset="100%" stopColor="#24275D" />
          </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
          <g>
            <path d="M0 0h666.9v300.6H0z" />
            <path
              fill="#646565"
              fillRule="nonzero"
              d="M655.4 310.1l-.1-2c1.9-8.8 3.9-19.6 5-42 1.2-23.8-4.2-36.9-4.6-46.9-.4-7.3 6.8-20.6-.4-23.1-.6-.2-1.1-.4-1.6-.5l.8-4.4 3 .9c.5.2 1 .4 1.5.4 1.8 0 3.2-1.4 3.2-3.2 0 0-1.7-9.2-1.8-12.3-.1-5.9 1.5-10.4-1-22.3-1.9-8.9-6.7-17.2-8.4-20.9-1.6-3.2-3.5-11.8-3.5-11.8-.4-1.3-1.6-2.3-3.1-2.3-1.6 0-2.9 1.1-3.1 2.6 0 0-.5 2-1.9 3.6-.3-.3-3.3-3-3.3-3 .6-.9 1-2 1-3.1 0-2.3-1.4-4.2-3.4-5l-1.8-.7c-3.5-1.4-5.9-4.8-5.9-8.7 0-3.9 2.7-7.5 5.6-8.9 2.7-1.2 5.7-2.1 11.5-3.5 10.9-2.5 22.6-14.4 22.6-26.6V9.5l-142.2.3-8.1-8.6-49.2.2-8.1 8.6-286.9.8s-8.2-8.2-8.4-8.2l-48.5.2-8.2 8.2-105 .3v60.5l61 58 45.7 87.2-3.8 4.5-56.4-.3L1 241.6v52.7l87.3.2 10.6-2.6 19.2-.1.1 14 11.7 1.3s6.6.7 9 1.6c2.4 1 76.2 30.2 77 30.5.8.3 2.6 0 2.6-2 0-2.1.2-43.8.2-45.1 0-1.4.7-2 2.2-2 1.5 0 19.3-.1 20.9-.1 1.6 0 2 .4 2 1.6v18.6l411.6-.1zm-71.9-154.8c-4.6.6-13.9 4-13.9 4-3.2 1.4-7.7 1.8-8 1.8-4.9 0-8.9-4-8.9-8.9s4-8.9 8.9-8.9c1.4 0 2.7.3 3.8.9.7.4 1.5.5 2.3.5 1.2 0 2.4-.5 3.2-1.2 2.6.8 4.7 1.7 6.5 2.4.1.4.2.7.4 1 .4.6 1.5 1 3.1 1.4 3.9.8 14.1 1.9 14.1 1.9s6.3.7 8.1-.4c2.7-.1 10.5 1.3 10.5 1.3-8.8 1.8-16.6 2-30.1 4.2zm33.1-6c-4.6-.8-5.9-1-10-1.4.4-.2 2.2-1.3 3.5-2.4 1.3-1.2 3.6-1.8 4.6-1.8 1 0 1.7-.6 2.1-1.4 3.6.5 6.3 3.1 7.4 6 .1 0-4-.9-7.6 1zm11.5-25.8c2.1 1.3 2.7 1.6 3.7 1.6s1.9-.3 2.6-.7l4.1 3.5c-.2.4-.3.9-.3 1.4 0 .9.3 1.6.9 2.2 0 0 10.5 9.9 13.7 27.2 2.3 13.2-1.2 22-1.9 28.7-.1 1 .7 2.2 1.6 2.8l-.9 5.3c-2.5.3-4.1 2.2-6.6 2.1-4.6 0-5.1-5.5-5.1-5.5l-3-29.4c-1.6-8.3-9-13.4-11-14.1-1.2-4.1-4.8-7.3-9.2-8 0 0-.4-1.5-2.1-1.5 0 0-2.9-.2-6.8 2.3-3.5 2.3-4.2 3.2-8.4 3.6-6.9.1-11.2-1.5-14.2-3.4-2-1.2-2-1.3-3.3-1.3-2.1 0-3.8 1.1-4.4 3-1.6-.7-3.3-1.3-5.4-2 .2-.5.3-1 .3-1.6 0-2.1-1.4-3.6-3.3-4.3 0 0-4.9-1.5-6.2-1.9-1.3-.4-5.6-2.4-5.6-2.4s-8.2-3.5-9.1-7.2c-.2-1-.4-2.4-.4-3.2.7-5.7 5.2-5.4 6.4-5 .7.3 1.6.9 4 .9s7.4-.1 12.8 0 9.4 2.6 11.1 3.6c1.6.9 3.2 1.7 5.1 1.7 4.6 0 8.4-3.5 8.8-8 .6.1 1.3.1 2 .1 2.3 0 4.4-.6 6.3-1.6 1.1 3.4 4.3 5.8 8 6 0 0 3.8.2 9.3 2.2 3.8 1.4 5.2 2.1 6.5 2.9z"
            />
            <path
              fill="#8F8D90"
              fillRule="nonzero"
              stroke="#000"
              strokeWidth=".5"
              d="M561 86.9h-23.9v8.3c1.2 0 3.3-.3 5 1.2 1.7 1.5 3.5 2 4.7 2 1.2 0 45.8.1 45.8.1.4-2.1 2.1-4.2 5-4.2 2.4 0 3.7 1.4 4.4 2.9l11.4-.1v-4.8c0-.4.1-.7.3-1l6.2-8.6c1-1.4 1.5-3.1 1.5-4.9V44.4H649c1.4.9 3 1.5 4.7 1.4 4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5c-1.9 0-3.7.7-5.1 1.8h-30.1v2L69 33.2v-2.4H40.5c-1.4-.9-3-1.5-4.7-1.5-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5c1.9 0 3.7-.7 5.1-1.8h25.3l.1 21.7c0 4.8 3.3 8.9 8.1 9.6l4.3.6.5 2.9-.4 2.9-3.7.6c-2.3.4-4.4 1.4-6 3.1l-23 23.1 12.4 12 5.3.6 12.6-9.6v-7.5L70.9 97l2.3-2.4 2.8-2.1c.2-.1.3-.2.5-.2h2.9c.5 0 .8.3.9.8l.4 2.9h7.7V83.6l1-7 8.9-1.4h21.2v11.7h-11.4v13.2h43.7v73h19.8l2.8-.9v-63c-.4.5-1 .9-1.8.9-1.2 0-2.1-.8-2.1-1.8v-4.8c0-1 .9-1.8 2.1-1.8 1.2 0 2.1.8 2.1 1.8v2.6h39v-6.7l102.7-.2.2-22.6c0-.3.2-.5.6-.5h4l5.9.3 4.2.9c.4.1.7.4.8.8l1.1 9.2v5.2l.1 137.1-1.3 8.1-9.6 1.4h-95.9l-10.2-1.4-1.3-2.1v-12.4h5.8v-17.7h-6.5v-25.4H209v2c0 .9-.6 1.2-1.2 1.2h-1.6v.6h-.5v5.8h.5v2.3h-4.5v31.3h5.9v12.6l-1 1.8-9.4 1.5s-138.1.1-142.5.1c-5.1.1-10 3-10 9v10.1H18.9c-1.4-.9-3-1.5-4.7-1.4-4.7 0-8.5 3.8-8.5 8.5s3.8 8.5 8.5 8.5c1.9 0 3.7-.7 5.1-1.8h28.1v-2.1l208.5-.3c2.6 0 4.5 2.4 4.5 5v5.1h10l-.6-5.2c0-2.6 1.7-4.9 4.3-4.9l175.7-.2c2.6 0 4.7 2.1 4.7 4.6l-.7 5.1h10.8l-.6-5.2c0-2.6 2.4-4.7 4.9-4.7l45-.1c2.5 0 4.9 1.3 6.5 3.2 1.6 2 2.4 4.6 2 7.2h9.9v-7.6h26.9c1.4.9 3 1.5 4.7 1.5 4.7 0 8.5-3.8 8.5-8.5s-3.8-8.5-8.5-8.5c-1.9 0-3.7.7-5.1 1.8h-26.4v-33.1c0-4.8-3.2-8.7-7.9-9.4l-6-.7c-.1 0-.2-.1-.2-.3v-29.5c-2.4-2.2-3.1-3.1-4.3-5l-1.3-.6h-16.2v24.8h-7.9V168h-14v-10.3l-3.1-.5h-49.1c-2.7 0-5.3 1.1-7.2 3l-17.6 17.6-17 17.1c-.4.4-.7.9-.7 1.5v5.6c0 .6-.5 1.2-1.1 1.2h-5c-1.2 0-2.2 1-2.2 2.3v12.6c0 .9-.8 1.7-1.8 1.7h-6.1l-9.2-1.4c-1.3-.2-2.2-1.2-2.4-2.4l-1.4-9.1v-14.2l1.1-7.1c.2-1.4 1.4-2.5 2.9-2.5h.9c2.8 0 5.6-1.2 7.4-3.1.7-.6 1-.6 1.6 0l7.4 7.4 5.9-5.7 18.8-18.4c2.3-2.4 3.7-5.5 3.7-8.8v-5c0-3.3-1.3-6.5-3.7-8.8l-18.8-18.4-5.8-5.6s-6.9 6.7-7.7 7.4c-.8.7-1.4 0-1.4 0-2-2-4.6-3.1-7.4-3.1h-.9c-1.4 0-2.7-1-2.9-2.5l-1.5-7.1V97.2l1.3-9.3c.2-1.3 1.6-2.5 2.9-2.6l8.9-1.5h6.2c1 0 2 1.1 2 2.1v12.5c0 1.2 1 2.3 2.3 2.3h5c.6 0 1.1.5 1.1 1.1v5.5c0 .6.2 1.1.7 1.5l19.6 19.5 15.1 15.1c1.9 1.9 4.6 3 7.3 3h49l2.1-.3c1.1-.2 1.1-.3 1.1-1.4l-.1-10.3h9.9c.6 0 .5-.6.5-.8 0-.5.4-.9 1-.9h2.7c.1 0 .5-.1.5-.5v-31.8c0-.4.1-1 .9-1h5.7c.5 0 .9.4.9.9v22h1.3c.1 0 .3 0 .4.1l3.7 1.3c.1 0 .3.1.4.1h10c.7 0 1.3-.3 1.7-.8l4.2-5.2V90.4l-1-.9v-5.6l1.4-7.3c0-.1.1-.2.2-.2l9.3-1.3h8.4l8.3 1.3c.1 0 .1.1.1.2.1 5.7 5.3 9.9 10.7 9.9h5c.1 0 .2.1.2.2l-.2.2z"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M628.1 123.5c2.1 1.3 2.7 1.6 3.7 1.6s1.9-.3 2.6-.7l4.1 3.5c-.2.4-.3.9-.3 1.4 0 .9.3 1.6.9 2.2 0 0 10.5 9.9 13.7 27.2 2.3 13.2-1.2 22-1.9 28.7-.1 1 .7 2.2 1.6 2.8l-.9 5.3c-2.5.3-4.1 2.2-6.6 2.1-4.6 0-5.1-5.5-5.1-5.5l-3-29.4c-1.6-8.3-9-13.4-11-14.1-1.2-4.1-4.8-7.3-9.2-8 0 0-.4-1.5-2.1-1.5 0 0-2.9-.2-6.8 2.3-3.5 2.3-4.2 3.2-8.4 3.6-6.9.1-11.2-1.5-14.2-3.4-2-1.2-2-1.3-3.3-1.3-2.1 0-3.8 1.1-4.4 3-1.6-.7-3.3-1.3-5.4-2 .2-.5.3-1 .3-1.6 0-2.1-1.4-3.6-3.3-4.3 0 0-4.9-1.5-6.2-1.9-1.3-.4-5.6-2.4-5.6-2.4s-8.2-3.5-9.1-7.2c-.2-1-.4-2.4-.4-3.2.7-5.7 5.2-5.4 6.4-5 .7.3 1.6.9 4 .9s7.4-.1 12.8 0 9.4 2.6 11.1 3.6c1.6.9 3.2 1.7 5.1 1.7 4.6 0 8.4-3.5 8.8-8 .6.1 1.3.1 2 .1 2.3 0 4.4-.6 6.3-1.6 1.1 3.4 4.3 5.8 8 6 0 0 3.8.2 9.3 2.2 3.8 1.4 5.2 2.1 6.5 2.9z"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M616.6 149.3c-4.6-.8-5.9-1-10-1.4.4-.2 2.2-1.3 3.5-2.4 1.3-1.2 3.6-1.8 4.6-1.8 1 0 1.7-.6 2.1-1.4 3.6.5 6.3 3.1 7.4 6 .1 0-4-.9-7.6 1zM583.5 155.3c-4.6.6-13.9 4-13.9 4-3.2 1.4-7.7 1.8-8 1.8-4.9 0-8.9-4-8.9-8.9s4-8.9 8.9-8.9c1.4 0 2.7.3 3.8.9.7.4 1.5.5 2.3.5 1.2 0 2.4-.5 3.2-1.2 2.6.8 4.7 1.7 6.5 2.4.1.4.2.7.4 1 .4.6 1.5 1 3.1 1.4 3.9.8 14.1 1.9 14.1 1.9s6.3.7 8.1-.4c2.7-.1 10.5 1.3 10.5 1.3-8.8 1.8-16.6 2-30.1 4.2z"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M655.4 310.1l-.1-2c1.9-8.8 3.9-19.6 5-42 1.2-23.8-4.2-36.9-4.6-46.9-.4-7.3 6.8-20.6-.4-23.1-.6-.2-1.1-.4-1.6-.5l.8-4.4 3 .9c.5.2 1 .4 1.5.4 1.8 0 3.2-1.4 3.2-3.2 0 0-1.7-9.2-1.8-12.3-.1-5.9 1.5-10.4-1-22.3-1.9-8.9-6.7-17.2-8.4-20.9-1.6-3.2-3.5-11.8-3.5-11.8-.4-1.3-1.6-2.3-3.1-2.3-1.6 0-2.9 1.1-3.1 2.6 0 0-.5 2-1.9 3.6-.3-.3-3.3-3-3.3-3 .6-.9 1-2 1-3.1 0-2.3-1.4-4.2-3.4-5l-1.8-.7c-3.5-1.4-5.9-4.8-5.9-8.7 0-3.9 2.7-7.5 5.6-8.9 2.7-1.2 5.7-2.1 11.5-3.5 10.9-2.5 22.6-14.4 22.6-26.6V9.5l-142.2.3-8.1-8.6-49.2.2-8.1 8.6-286.9.8s-8.2-8.2-8.4-8.2l-48.5.2-8.2 8.2-105 .3v60.5l61 58 45.7 87.2-3.8 4.5-56.4-.3L1 241.6v52.7l87.3.2 10.6-2.6 19.2-.1.1 14 11.7 1.3s6.6.7 9 1.6c2.4 1 76.2 30.2 77 30.5.8.3 2.6 0 2.6-2 0-2.1.2-43.8.2-45.1 0-1.4.7-2 2.2-2 1.5 0 19.3-.1 20.9-.1 1.6 0 2 .4 2 1.6v18.6l411.6-.1z"
            />
            <path
              fill="#BAB9BA"
              fillRule="nonzero"
              d="M606.3 40.6c.2 0 .3 0 .5.1 5.6 2.3 8.6 6.4 7.7 11.8-.6 3.1-2.2 3.7-2.9 3.8l-5.4.6c-.3 0-.6 0-.8-.2-.2-.2-.3-.4-.3-.6V41.5c0-.3.5-.6.7-.8.2 0 .3-.1.5-.1h-15.2c2.9 0 5.7 1.4 7.5 3.9 1.9 2.4 2.6 5.7 2.2 8.8l-.2 1.1c-.2 1-1.8 1.5-2.2 1.6l-8.4 1.5h-25.8l-9.1-1.6c-.8-.2-1.4-.8-1.7-2l-.8-6.2c-.2-1.8.2-3.6 1.3-5s2.6-2.2 4.2-2.2h-15c1.6 0 3 .7 4 2.1 1 1.4 1.8 3.1 1.5 4.8l-.9 6.3c-.3 1.4-1.6 2-2.7 2.3l-8.2 1.3h-52.6c-10.3 0-22.5-4.7-31.4-10.5l-8.1-5c-.2-.1-.3-.5-.3-.7.1-.3.2-.4.5-.5h-22.3c.3.3.5 1.3-.5 1.9-1.4.9-12.3 7.1-12.7 7.4-13.6 8.6-31.8 8.5-44.8 7.6l-6.6-1.2c-.7-.2-2.1-.6-2.6-1.9-.5-1.4.6-2.7 1-3.2l3.7-3c11.4-7 20.5-7.5 26.7-7.5l-24.4.3c.3.1.5.3.5.7.1.4-.1.7-.4.9l-21.2 12.3c-.2.1-.5.1-.8 0-.3-.1-.4-.4-.5-.6l-.7-6.1c-.4-2.5 1.1-7.1 5.6-7.1h-15.2c4.5 0 5.9 4.6 5.6 7.1l-.7 6.1c0 .3-.2.5-.5.6-.3.1-.6.1-.8 0l-21.2-12.2c-.3-.2-.5-.5-.4-.9.1-.3.2-.6.5-.7l-19.1.3c10.7 1.5 16.5 3.6 21.4 7.1l3.7 3c.4.5 1.6 1.8 1 3.2-.5 1.2-1.9 1.7-2.6 1.9l-6.6 1.2c-8.7 1.1-20.9-1-34.6-9.6-.4-.2-.5-.6-.4-.8 0-.2.3-.6.6-.8 5.6-2.4 11.5-4.2 17.5-5.1h-19.3c.4 0 .8.3.9.7.1.4-.1.8-.4 1l-3.5 2c-.3.2-.6.2-.9 0l-3.4-2c-.4-.2-.5-.6-.4-1 .1-.4.5-.7.9-.7l-25.1-.1c8.3 0 16.1 1.6 23.8 5.4.2.1.3.3.4.6 0 .2-.1.5-.3.6-9.2 6.4-20.9 10.3-31.7 10.3h-63l-8.2-1.3c-.7-.2-2-.9-2.2-2.1l-1-6.3c-.2-1.8.2-3.6 1.2-4.9 1-1.4 2.6-2.1 4.1-2.1h-15.8c4.2 0 7 2.6 6.8 5.8l-.7 7.1c-.1.7-1 2.3-3.1 2.7l-8.5 1.3H98.5l-8.8-1.3c-1.2-.2-2.7-1.7-2.8-3.7V50c-.1-3.8 5.2-8.3 10.2-8.3H81.6c.2 0 .3 0 .5.1.3.1.7.5.7.8v14.5c0 .2-.1.5-.3.6-.2.2-.5.2-.8.2l-5.4-.6c-.7-.1-2.3-.7-2.9-3.8-.8-5.3 2.1-9.5 7.7-11.7.1-.1.3-.1.5-.1H69.2s-.1 24.2-.1 26.4c0 2.2 3.3 5 5.4 5.3l4.5.6c.8 0 2.4 1.2 2.6 2.7.2 1.5.5 3 .5 3s-.2 2.1-.3 3.3c-.1 1.2-1.4 2.4-2.6 2.6l-3.5.5c-1.1.1-3.1 1-4.5 2.4l-4.4 4.4 3 3.1c.8-.8 4.4-3.9 5.1-4.6.7-.7 1.3-.5 1.9-.5.6 0 3.1.1 3.1.1 4-.1 6.2-4.7 6.3-6.2.2-1.5.3-2.6.3-2.6s.5-4.3.7-5.6c.2-1.4 1.2-2.4 2.9-2.7 1.7-.3 7.4-1.2 7.4-1.2h9.4c1.1 0 1.7.4 1.7 1.7v12.9h31.5v-9.5H139v-3.2c0-1.1.9-2 2-2 0 0 .7-.1 2.3 0 2.2.2 4.2.5 5.6.9 1.3.3 1.9.4 3.3.4s2.8 1.4 2.8 3c0 .3-.1.7-.2 1h-2.9v84h22v-51.7c-.3.2-.8.4-1.3.4-1.2 0-2.1-.8-2.1-1.8V104c0-1 .9-1.8 2.1-1.8 1.2 0 2.1.8 2.1 1.8v-9.1h37.1v-6.8c-.2 0-.4.1-.6.1-.5 0-2.5-.6-2.5-2.1v-5.3l.6-4.2c.1-.5.7-2 2.5-1.9 1.7.1 1.9 1.5 2 2.7v.4h101.9v-3.2c0-1.1 1.1-2.1 2.4-2.1 0 0 .9-.1 2.8 0 2.9.3 8.6 1 11.2 1.3 1.7.2 2.2 1.2 2.6 4l1.2 9.6.1 141v2.4l-1 7.2c-.4 1.5-2 2.1-3.1 2.3l-6.9 1.3h-98.8l-9.4-1.3c-2.4-.2-2.7-2.8-2.7-2.8l-1-8.1.1-6.5h-3.3v6.6s-1.1 7.4-1.2 8.3c-.1.9-1 2.3-2.4 2.6-1.4.2-9.5 1.5-9.5 1.5H57.1c-5.4 0-9.7 1.6-9.602 6.9v12.8H59.9c-.2 0-.4 0-.5-.1-4.5-1.2-8.5-6.8-7.6-12 .7-3.1 2.2-3.3 3.3-3.6l4.9-.8c.3 0 .6 0 .8.2.2.2.4.4.4.6v14.6c0 .3-.5.8-.8.9-.2.1-.3.1-.5.1h15.9c-3.1 0-6.1-1.5-8.1-3.9-2.1-2.5-2.7-5.9-2.2-8.8.6-1.7 1.1-2.4 2.7-2.7l8.9-1.6h29.8l9.6 1.4c1.1.2 2 1 2.3 2.7l.9 5.8c.3 1.8-.2 3.6-1.4 5s-2.8 2.2-4.6 2.2l15.5-.1c-1.6 0-3.2-.8-4.3-2.2-1.1-1.4-1.6-3.2-1.3-5l.8-5.9c.2-1.2 1.2-2 2.4-2.3l8-1.5h21.3c10.7 0 21.1 3 30.4 8.8l10.6 6.8c.2.2.4.5.3.8-.1.3-.3.5-.6.5l21.7-.1c-1.2 0-13.2-2.3-13.2-2.3l-9-3.7-5.6-4.5c-.6-.5-1-1.3-1-2.2 0-1.5 1.2-2.8 2.6-3l7.1-1.2h37.1l8.4 1.3c1.2.4 2.1 1.5 2.1 2.9 0 1-.5 1.9-1.3 2.4l-5 4-9.2 3.8s-11.9 2.4-13.1 2.4h22.1c-.3-.1-.7-.4-.8-.7-.1-.3 0-.9.3-1.1l20.9-12.2c.2-.1.8-.3 1-.2.2.1.6.3.6.6l.7 5.5c.3 2.2 0 4.5-1.6 6.1-1.6 1.6-2.9 2-6.6 2h19.2c-2.2-.1-3.8-.6-5.2-2-1.6-1.6-2-3.9-1.6-6.1l.7-5.5c0-.3.2-.5.4-.6.2-.1.5-.1.7 0l19.2 11.1c.3.2.4.5.4.8-.1.3-.3.6-.6.6-4.2.8-8.6 1.4-12.8 1.6l43.2-.1c-5.3 0-10.5-.1-15.7-1.2-.3-.2-.8-.4-.8-1.1 0-.3.1-.8.7-1.1l12.5-7c.2-.1.5-.1.8 0l14.6 8.2c.5.3.6 1 .5 1.3-.1.3-.4.8-.7.8h27c-8.4 0-18-2.2-18-2.2l-9-3.7-5.6-4.5c-.6-.5-1-1.3-1-2.2 0-1.5 1.1-2.8 2.6-3l7.1-1.2h47.2l8.4 1.3c1.2.4 2.1 1.5 2.1 2.9 0 1-.5 1.9-1.3 2.4l-5 4-9.2 3.8s-10 2.2-18.4 2.3l26.7-.1c-.3 0-.5-.2-.6-.5-.1-.3 0-.6.3-.7l10.6-6.7c9.3-5.8 19.8-8.7 30.5-8.7h21.4l8 1.5c1.2.3 2.2 1.1 2.4 2.3l.8 5.8c.2 1.8-.2 3.6-1.3 4.9-1.1 1.4-2.6 2.1-4.3 2.1l15-.1c-1.6 0-3.2-.8-4.2-2.1-1.1-1.3-1.5-3.1-1.3-4.9l.8-5.6c.3-1.6 1.1-2.4 2.1-2.6l8.8-1.3h27.3l8 1.2c1.1.1 2.4.5 2.9 2.9.5 2.8-.4 6.3-2.3 8.7-1.9 2.4-4.6 3.9-7.4 3.9h15.2c-.2 0-.3 0-.5-.1-.3-.1-.8-.7-.8-.9v-14.6c0-.2.1-.5.4-.6.2-.2.5-.2.8-.2l5.7.8c1.2.2 2.7.5 3.3 3.6.8 5.2-2.3 10.3-8.4 11.9-.2.1-.3.1-.5.1l13.1.1-.1-36.2c0-4.1-2.8-6.1-5.7-6.6-2.9-.5-4.5-.7-6.1-.9-1.6-.2-2.8-1.6-2.8-2.9V183l-1.9-2.1-3.3-1.4h-2.6l-23.6-.1.2-57.8h29l2.1-1.8V82.4l1.1-7.1c.3-1.5 1.7-2.2 2.7-2.3 1-.1 9.3-1.3 9.3-1.3h8.4s8.3 1 9.1 1.1c1.3.2 2.8 1.1 2.7 3.4 0 5.1 4.8 7 7.4 7h5c.8 0 1.5.8 1.5 1.7v2h53.9l1.4-1.8c1-1.4 1.4-4.4 1.4-6.1l.1-38.4h-12.8zM80.6 67.4h-4.3c-.8 0-1.1-.6-1.1-1.1v-3.5h5.4v4.6zm72.8.8l-8.5 1.3h-46L89.8 68c-1.7-.5-2.6-1.5-2.6-2.9 0-1.5 1.1-2.4 2.7-2.9l10.5-1.5h43.5l9.3 1.4c1.7.4 2.8 1.3 2.8 3 0 1.6-1.2 2.8-2.6 3.1zm12.9 15.9c0 1.6-1.3 2.9-2.9 2.9-1.6 0-2.9-1.3-2.9-2.9v-7.6c0-1.6 1.3-2.9 2.9-2.9 1.6 0 2.9 1.3 2.9 2.9v7.6zM163.5 68c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3c-.1 1.6-1.4 3-3 3zm11-6l9.2-1.2h9.4l8.2 1.2c1.6.1 2.8 1.4 2.8 3 0 1.4-1 2.6-2.3 2.9l-11.5 1.5h-4.5l-11.5-1.5c-1.3-.3-2.3-1.5-2.3-2.9-.1-1.5 1-2.8 2.5-3zm30.1 19.7c-.2 3.3-1.6 4.9-2.7 5.1l-3.3.7h-21.1l-3.6-.6c-1.6-.3-2.3-2.1-2.5-5.7v-1.5-1.8c.2-3.4 1.7-4.4 2.9-4.6l9.1-1.3h9.1l9.9 1.5c1.3.3 2 .9 2.2 4.2 0 .6.1 1.3.1 2-.1.8-.1 1.4-.1 2zm65.8-31.2c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm-26.6 17.4l-13.2 1.5h-5.2l-13.2-1.5c-1.5-.3-2.6-1.5-2.6-2.9 0-1.5 1.3-2.8 2.9-3l10.5-1.2h10.8l9.4 1.2c1.8.1 3.2 1.4 3.2 3 .1 1.4-1 2.5-2.6 2.9zm42.3-.1l-13.2 1.5h-5.2l-13.2-1.5c-1.5-.3-2.6-1.5-2.6-2.9 0-1.5 1.3-2.8 2.9-3l10.5-1.2h10.8l9.4 1.2c1.8.1 3.2 1.4 3.2 3 0 1.4-1.1 2.6-2.6 2.9zm45.8 0l-14.6 1.5h-5.7L297 67.8c-1.7-.3-2.9-1.5-2.9-2.9 0-1.5 1.4-2.8 3.2-3l8.4-1.4h17.7l8 1.4c2 .1 3.5 1.4 3.5 3-.1 1.4-1.3 2.6-3 2.9zm-26.6 183.4l-5 4c-1.7 1-3.6 1.6-5.4 2.4-1.8-.8-3.5-1.4-5.3-2.4l-5-3.8c-.4-.3-1.7-1.1-1.6-3.1.1-1.6 1.5-2.3 2.4-2.4l9.4-1.6s8.6 1.4 9.4 1.5c1.1.1 2.3 1.3 2.4 2.4.3 1.1-.2 2.2-1.3 3zM417 50.9l5-4 8.7-3.7s1.9-.7 3-.7c1.2 0 3 .7 3 .7l8.6 3.4 5.6 4.5c.6.5 1 1.3 1 2.2 0 1.5-1.1 2.8-2.6 3l-7.1 1.2h-16l-8.4-1.3c-1.2-.4-2.1-1.5-2.1-2.9 0-.9.5-1.8 1.3-2.4zm-13.9 28.2c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3c0 1.6-1.3 3-3 3zm3.2 146.7c0 1.7-1.3 3-3 3s-3-1.3-3-3 1.3-3 3-3 3 1.4 3 3zm-62-164.2l8.1-1h30.9l7.4.9c2.6.1 4 1.7 4 3.3 0 1.5-1.4 3.1-3.7 3.4l-14.7 1.1h-17.7L343.9 68c-2.3-.3-3.6-1.7-3.6-3.2 0-1.5 1.5-3 4-3.2zm50.4 14.5c0 1.4-1.2 2.7-2.9 3l-10.3 1.4h-18l-9.2-1.3c-1.7-.3-2.7-1.7-2.7-3.1 0-1.5 1.2-2.8 3-3l8.9-1.2h19.4l8.4 1.2c2 .1 3.4 1.4 3.4 3zm-51.5-2.9c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-1.6 1.3-3 3-3zm.3 167.1c-1.7 0-3-1.3-3-3s1.3-3 3-3c1.6 0 3 1.3 3 3s-1.3 3-3 3zm0-11.3c-1.7 0-3-1.3-3-3s1.3-3 3-3c1.6 0 3 1.3 3 3s-1.4 3-3 3zm4.2-22.7l-1.4 9.1c-.2 1.4-1.4 2.5-2.9 2.5-1.4 0-2.7-1-2.9-2.5l-1.4-9.1v-14.2l1.4-9.2c.2-1.4 1.4-2.5 2.9-2.5 1.4 0 2.7 1 2.9 2.5l1.4 9.2v14.2zm-7.2-64.6c.2-1.4 1.4-2.5 2.9-2.5 1.4 0 2.6 1 2.9 2.5l1.2 7.4v4.6l-1.2 7.3c-.2 1.4-1.4 2.5-2.9 2.5-1.4 0-2.6-1-2.9-2.5l-1.1-7.3v-4.6l1.1-7.4zm-.3-11.2c0-1.7 1.3-3 3-3 1.6 0 3 1.3 3 3s-1.3 3-3 3c-1.6 0-3-1.3-3-3zm6 41.1c0 1.7-1.3 3-3 3s-3-1.3-3-3c0-1.6 1.3-3 3-3s3 1.3 3 3zm1.5-60.9l-1.4 9.1c-.2 1.4-1.4 2.5-2.9 2.5-1.4 0-2.6-1-2.9-2.5l-1.4-9.1V96.5l1.4-9.3c.2-1.4 1.4-2.5 2.9-2.5 1.4 0 2.6 1 2.9 2.5l1.4 9.3v14.2zm3.4 32c-.1-2.9.7-6.7 1.1-10.1.2-1.9 2.8-3.4 4.4-1.9 2.4 2.2 18.3 18 19.3 19s1.1 2.1-.1 3.3l-19 19c-2 2-4.8.1-5.1-1.9-.2-2-.7-5.2-.7-9.1.1-3.9.2-15.4.1-18.3zm3.1 80.4l9.3-1.4 20 .1 9 1.3c2.2.1 3.2 1.3 3.2 2.9 0 1.4-1.3 2.7-3.2 3l-9.2 1.3h-19.9l-9.4-1.1c-1.9-.3-2.8-1.8-2.8-3.3 0-1.6 1-2.6 3-2.8zm48.5 17.5l-10.9 1.1h-26.3l-10.2-1.3c-2.3-.3-3.6-1.7-3.6-3.1 0-1.5 1.5-3 4-3.2l8.2-1H395l7.4.9c2.7.1 4.1 1.7 4.1 3.2-.1 1.5-1.5 3.1-3.8 3.4zm37.5-142.7h-3.1c-.3 0-.6-.1-.8-.3l-7.7-7.7c-.2-.2-.2-.4-.1-.6.1-.2.3-.3.5-.3h11.2c.6 0 1.1.5 1.1 1.1v6.7c.1.6-.5 1.1-1.1 1.1zm.8 108v6.7c0 .6-.5 1.1-1.1 1.1h-11.2c-.2 0-.4-.1-.5-.3-.1-.2 0-.4.1-.6l7.7-7.8c.2-.2.5-.3.8-.3h3.1c.6 0 1.1.5 1.1 1.2zM423.8 80.3l-9.4-1.1c-1.9-.3-2.8-1.8-2.8-3.3 0-1.5 1-2.5 3-2.7l9.3-1.4 20 .1 9 1.3c2.2.1 3.2 1.3 3.2 2.9 0 1.4-1.3 2.7-3.2 3l-9.2 1.3-19.9-.1zm29.5 159.8l-9.2 1.3h-19.9l-9.4-1.1c-1.9-.3-2.8-1.8-2.8-3.3 0-1.5 1-2.5 3-2.7l9.3-1.4 20 .1 9 1.3c2.2.1 3.2 1.3 3.2 2.9-.1 1.4-1.4 2.6-3.2 2.9zm0-11.2l-9.2 1.3h-19.9l-9.4-1.1c-1.9-.3-2.8-1.8-2.8-3.3 0-1.5 1-2.5 3-2.7l9.3-1.4 20 .1 9 1.3c2.2.1 3.2 1.3 3.2 2.9-.1 1.3-1.4 2.6-3.2 2.9zm-6.5-159.6h-29.1L404.2 68c-2.8-.3-3.9-1.8-3.9-3.3 0-1.5 1.5-3.1 4.6-3.3l8.2-.9h42.1l8.4 1c3.3.1 4.1 1.7 4.1 3.3 0 1.5-.9 2.8-3.7 3.1l-17.2 1.4zm17.7 3.7c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3c0-1.6 1.3-3 3-3zm.4 167.2c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3c0 1.6-1.4 3-3 3zm0-11.6c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.4 3-3 3zm53.9-5.8h3.2c1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9h-3.2c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9zm.1 11.2h3.2c1.6 0 2.9 1.3 2.9 2.9 0 1.6-1.3 2.9-2.9 2.9h-3.2c-1.6 0-2.9-1.3-2.9-2.9 0-1.6 1.3-2.9 2.9-2.9zm-11.2 5.9l-8.6 1.4H485l-9.1-1.4c-1.5-.3-2.7-1.5-2.7-2.9 0-1.5 1.3-2.8 3-3l9-1.2h13.3l8.7 1.2c1.8.1 3.3 1.4 3.3 3-.1 1.4-1.3 2.5-2.8 2.9zM484 221.7h16.2l7.3 1.2c1.8.1 3.3 1.4 3.3 3 0 1.4-1.2 2.6-2.7 2.9l-11.1 1.5h-9.7l-11.5-1.5c-1.5-.3-2.7-1.5-2.7-2.9 0-1.5 1.3-2.8 3-3l7.9-1.2zM507.6 79l-8.9 1.3h-13.3l-9.7-1.5c-1.5-.3-2.6-1.5-2.6-2.9 0-1.5 1.3-2.8 2.9-3l8.4-1.2h15.1l7.8 1.2c1.8.1 3 1.4 3 3 0 1.4-1.2 2.8-2.7 3.1zm36.8-11.3l-15.5 1.4h-38.6l-13.5-1.3c-2.8-.3-3.9-1.8-3.9-3.3 0-1.5 1.5-3.1 4.6-3.3l8.2-.9h49.9l8.4 1c3.3.1 4.1 1.7 4.1 3.3 0 1.5-.9 2.8-3.7 3.1zm62.8-5.5h5.4v3.5c0 .5-.3 1.1-1.1 1.1h-4.3v-4.6zm-55.3 2.3c0-1.5 1-2.9 3.4-3.2l8.2-1.1h25.8l7.8 1.2c2.8.3 3.6 1.4 3.6 3 0 1.4-.8 2.5-3.3 3.1l-8.4 1.3h-25.5l-8.3-1.2c-2.2-.3-3.3-1.6-3.3-3.1zm58.9 14.6l-7.4 1.1h-39l-7.2-1.1c-2.6-.3-3.7-2-3.7-3.2 0-.6.1-2.8 4.1-3.4l10.6-.9h34.2l8.3 1.1c2.6.4 3.5 1.8 3.5 3.4 0 1.4-1.2 2.7-3.4 3z"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M157.8 76.3c0-3.1 2.5-5.7 5.7-5.7M152.1 70.6c3.1 0 5.7 2.5 5.7 5.7M163.5 70.6c-3.1 0-5.7-2.5-5.7-5.7 0 3.1-2.5 5.7-5.7 5.7M84.1 76.3c0-3.1 2.5-5.7 5.7-5.7M78.4 70.7c3.1 0 5.7 2.5 5.7 5.7M89.8 70.7c-3.1 0-5.7-2.5-5.7-5.7M89.8 59.3c-3.1 0-5.7-2.5-5.7-5.7M70.6 51.5V65M76.3 70.7c-3.1 0-5.7-2.6-5.7-5.7M169.1 76.3c0-3.1 2.5-5.7 5.7-5.7M163.4 70.6c3.1 0 5.7 2.5 5.7 5.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M174.8 70.6c-3.1 0-5.7-2.5-5.7-5.7 0 3.1-2.5 5.7-5.7 5.7M206.9 76.3c0-3.1 2.5-5.7 5.7-5.7M201.3 70.6c3.1 0 5.7 2.5 5.7 5.7M212.6 70.6c-3.1 0-5.7-2.5-5.7-5.7 0 3.1-2.5 5.7-5.7 5.7M157.8 64.9c0-3.1 2.5-5.7 5.7-5.7M152.1 59.2c3.1 0 5.7 2.5 5.7 5.7M163.5 59.2c-3.1 0-5.7-2.5-5.7-5.7 0 3.1-2.5 5.7-5.7 5.7M169.1 65v92.8M169.1 95.4c0-3.1 2.5-5.7 5.7-5.7M163.4 89.7c3.1 0 5.7 2.5 5.7 5.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M174.8 89.7c-3.1 0-5.7-2.5-5.7-5.7 0 3.1-2.5 5.7-5.7 5.7M348.9 76v161.8M349 87.3c0-3.1 2.5-5.6 5.7-5.6M343.3 81.7c3.1 0 5.6 2.5 5.6 5.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M354.6 81.7c-3.1 0-5.7-2.6-5.7-5.8 0 3.1-2.5 5.7-5.6 5.7M550.8 76.1V49.6M556.5 70.4c-3.1 0-5.7-2.5-5.7-5.7M556.5 81.6c-3.1 0-5.7-2.5-5.7-5.7M550.8 76.1c0-3.1 2.5-5.7 5.7-5.7M550.8 64.8c0 3.1-2.5 5.7-5.7 5.7 3.1 0 5.7 2.5 5.7 5.7M556.5 59.1c-3.1 0-5.7-2.5-5.7-5.7M550.8 64.8c0-3.1 2.5-5.7 5.7-5.7M550.8 53.4c0 3.1-2.5 5.7-5.7 5.7 3.1 0 5.7 2.5 5.7 5.7M512.8 119.6V76.1c0 3.1-2.5 5.7-5.7 5.7 3.1 0 5.7 2.5 5.7 5.7M512.8 76.2c0-3.1 2.5-5.7 5.7-5.7M507.1 70.5c3.1 0 5.7 2.5 5.7 5.7M617.1 64.7c0 3.1-2.5 5.7-5.7 5.7M617.1 75.8c0 3.1-2.5 5.7-5.7 5.7M611.4 70.4c3.1 0 5.7 2.5 5.7 5.7M617.1 53.4c0 3.1-2.5 5.7-5.7 5.7M603.3 50.8v13.9c0 3.1-2.5 5.7-5.7 5.7M603.3 53.4c0 3.1-2.5 5.7-5.7 5.7M337.4 70.7v-23M348.9 59.2h-23.1M337.4 53.5c0 3.1-2.5 5.7-5.7 5.7M343 59.2c-3.1 0-5.7-2.5-5.7-5.7M211.4 237.8v-57.3M211.5 237.4c0 3.1-2.5 5.6-5.7 5.6M216.8 243.1c-3.1 0-5.4-2.5-5.4-5.6M265 243v11.6M265 248.7c0-3.1 2.5-5.7 5.7-5.7M259.3 243c3.1 0 5.7 2.5 5.7 5.7M513.2 181.5v69.3M507.5 242.9c3.1 0 5.7 2.5 5.7 5.7M522.2 231.5c3.1 0 5.7 2.5 5.7 5.7M459.1 248.6c0-3.1 2.5-5.7 5.7-5.7M453.5 243c3.1 0 5.7 2.5 5.7 5.7M121.5 248.4v4.2M109.9 243.1H133M121.5 248.8c0-3.1 2.5-5.7 5.7-5.7M115.8 243.1c3.1 0 5.7 2.5 5.7 5.7M206.9 65v19.1c0 3.1-2.5 5.7-5.7 5.7h-37.9M169.1 64.9c0-3.1 2.5-5.7 5.7-5.7M163.4 59.2c3.1 0 5.7 2.5 5.7 5.7M157.8 157.8V50.1M163.5 89.7c-3.1 0-5.7-2.5-5.7-5.7M157.8 95.4c0-3.1 2.5-5.7 5.7-5.7M206.9 64.9c0-3.1 2.5-5.7 5.7-5.7M201.3 59.2c3.1 0 5.7 2.5 5.7 5.7M397.4 81.9h23.1M409 87.5c0-3.1 2.5-5.7 5.7-5.7M403.3 81.9c3.1 0 5.7 2.5 5.7 5.7M409 76.2c0 3.1-2.5 5.7-5.7 5.7M414.7 81.9c-3.1 0-5.7-2.5-5.7-5.7M337.6 237.6l-.2-176.8M343.1 81.7c-3.1 0-5.7-2.5-5.7-5.7M337.4 87.3c0-3.1 2.5-5.7 5.7-5.7M349 76.2c0-3.1 2.5-5.7 5.7-5.7M343.3 70.6c3.1 0 5.7 2.5 5.7 5.7M337.4 76.2c0-3.1 2.5-5.7 5.7-5.7M331.7 70.6c3.1 0 5.7 2.5 5.7 5.7M409 76.2c0-3.1 2.5-5.7 5.7-5.7M403.3 70.5c3.1 0 5.7 2.5 5.7 5.7M397.4 87.5c0-3.1 2.5-5.7 5.7-5.7M391.7 81.9c3.1 0 5.7 2.5 5.7 5.7M249.2 64.9c0-3.1 2.5-5.7 5.7-5.7M243.6 59.2c3.1 0 5.7 2.5 5.7 5.7M249.3 64.9c0 3.1-2.5 5.7-5.7 5.7M254.9 70.6c-3.1 0-5.7-2.5-5.7-5.7M291.5 64.9c0-3.1 2.5-5.7 5.7-5.7M285.8 59.2c3.1 0 5.7 2.5 5.7 5.7M257.4 41c7.3 2.4 10.9 5.1 15.7 7.6 4 2.1 17.1 10.6 29.9 10.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M291.5 65.3v-3.5c0-2.5-1.7-3.7-3.2-4.5-1.5-.9-11.3-6.5-11.3-6.5M283.3 41c-7.3 2.4-10.9 5.1-15.7 7.5-4 2.1-17.1 10.7-29.9 10.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M249.2 65.3v-3.5c0-2.5 1.7-3.7 3.2-4.5 1.5-.9 11.1-6.5 11.1-6.5M291.5 64.9c0 3.1-2.5 5.7-5.7 5.7M297.2 70.6c-3.1 0-5.7-2.5-5.7-5.7M270.3 47.8c3.1 0 5.7 2.5 5.7 5.7M276 53.6c0 3.1-2.5 5.7-5.7 5.7M264.6 53.5c0-3.1 2.5-5.7 5.7-5.7M270.3 59.2c-3.1 0-5.7-2.5-5.7-5.7"
            />
            <circle
              cx="343.2"
              cy="171.6"
              r="5.7"
              stroke="#575759"
              strokeWidth=".5"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M337.6 225.9c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.5 5.7-5.7 5.7s-5.7-2.6-5.7-5.7zM397.7 225.9c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.5 5.7-5.7 5.7s-5.7-2.6-5.7-5.7zM459.1 225.9c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.5 5.7-5.7 5.7-3.1-.1-5.7-2.6-5.7-5.7z"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M476.1 231.5c-3.1 0-5.7-2.5-5.7-5.7 0-3.1 2.5-5.7 5.7-5.7M470.5 214.6c0 3.1-2.6 5.6-5.7 5.6s-5.7-2.5-5.7-5.7M409 214.5c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.5-5.7-5.7M414.7 220.2c-3.1 0-5.7-2.5-5.7-5.7M397.7 214.5c0 3.1-2.5 5.7-5.7 5.7M476.1 220.2c-3.1 0-5.7-2.5-5.7-5.6M459.1 214.5c0 3.1-2.5 5.7-5.7 5.7M337.6 237.3c0 3.1-2.5 5.8-5.7 5.8M388.3 243c3.1 0 5.7 2.5 5.7 5.6 0 0 .2 2.9-2.5 4.4M398.5 249c6.3-3.7 17.2-6 21.2-6M476.1 243c-3.1 0-5.7-2.6-5.7-5.8 0-3.1 2.5-5.7 5.7-5.7M453.5 231.5c3.1 0 5.7 2.6 5.7 5.7s-2.5 5.7-5.7 5.7M507.5 231.5c3.1 0 5.7 2.6 5.7 5.7s-2.5 5.7-5.7 5.7M518.9 231.5c-3.1 0-5.7-2.6-5.7-5.7s2.5-5.6 5.7-5.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M507.5 220.2c3.1 0 5.7 2.5 5.7 5.6 0 3.1-2.5 5.7-5.7 5.7M518.9 220.2c-3.1 0-5.7-2.6-5.7-5.8M513.2 214.4c0 3.1-2.5 5.7-5.7 5.7M414.8 243c-3.1 0-5.7-2.6-5.7-5.8 0-3.1 2.5-5.7 5.7-5.7M403.4 231.6c3.1 0 5.7 2.6 5.7 5.7s-2.5 5.7-5.7 5.7M453.5 220.2c3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.5 5.7-5.7 5.7M414.7 231.5c-3.1 0-5.7-2.5-5.7-5.7 0-3.1 2.5-5.7 5.7-5.7M392 220.2c3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.5 5.7-5.7 5.7M354.6 231.6c-3.1 0-5.7-2.5-5.7-5.7 0-3.1 2.5-5.7 5.7-5.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M354.6 243c-3.1 0-5.7-2.6-5.7-5.8 0-3.1 2.5-5.7 5.7-5.7M459.1 237.2c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.5 5.8-5.7 5.8-3.1 0-5.7-2.7-5.7-5.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M337.6 237.3c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7 0 3.1-2.5 5.7-5.7 5.7-3.2-.1-5.7-2.6-5.7-5.7z"
            />
            <circle
              cx="343.2"
              cy="130.5"
              r="5.7"
              stroke="#575759"
              strokeWidth=".5"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M348.9 119.2c0 3.1-2.6 5.7-5.7 5.7s-5.7-2.5-5.7-5.7M348.9 160.3c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.5-5.7-5.7M348.9 214.6c0 3.1-2.5 5.7-5.7 5.7-3.1 0-5.7-2.5-5.7-5.7M337.5 141.9c0-3.1 2.6-5.7 5.7-5.7s5.7 2.6 5.7 5.7M337.5 183c0-3.1 2.5-5.7 5.7-5.7 3.1 0 5.7 2.5 5.7 5.7M385.9 59.2H76.3c-3.1 0-5.7-2.5-5.7-5.7M337.4 64.9c0-3.1 2.5-5.7 5.7-5.7M331.7 59.2c3.1 0 5.7 2.5 5.7 5.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M358.8 59.2c-3.1 0-5.7-2.5-5.7-5.7 0 0-.2-3.2 2-4.5"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M337.4 62.6c0-1.9.9-3.5 2.3-4.5L369 41M315.9 59.2c3.1 0 5.7-2.5 5.7-5.7 0 0 .2-3.2-2.1-4.5"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M337.4 62.7c0-1.9-.9-3.6-2.4-4.6L305.7 41M337.4 64.9c0 3.1-2.5 5.7-5.7 5.7M343.1 70.6c-3.1 0-5.7-2.5-5.7-5.7M397.4 64.8c0-3.1 2.5-5.7 5.7-5.7M391.7 59.2c3.1 0 5.7 2.5 5.7 5.7M397.4 64.9c0 3.1-2.5 5.7-5.7 5.7M403.1 70.5c-3.1 0-5.7-2.5-5.7-5.7M418.8 59.2c-3.1 0-5.7-2.5-5.7-5.7 0 0-.3-3.5 2.6-5M397.4 76.2c0-3.1 2.5-5.7 5.7-5.7M391.7 70.5c3.1 0 5.7 2.5 5.7 5.7M397.4 76.2c0 3.1-2.5 5.7-5.7 5.7M403.1 81.9c-3.1 0-5.7-2.5-5.7-5.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M385.9 59.2h72.9l80.5-.1h72.1M470.3 64.8c0-3.1 2.5-5.7 5.7-5.7M464.7 59.1c3.1 0 5.7 2.5 5.7 5.7M470.4 64.8c0 3.1-2.5 5.7-5.7 5.7M476 70.5c-3.1 0-5.7-2.5-5.7-5.7M470.3 76.2c0-3.1 2.5-5.7 5.7-5.7M464.7 70.5c3.1 0 5.7 2.5 5.7 5.7M470.4 76.2c0 3.1-2.5 5.7-5.7 5.7M476 81.9c-3.1 0-5.7-2.5-5.7-5.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M611.4 70.4h-71.9c-129.7.2-259.5.2-389.2.2h-74M458.8 76.2c0-3.1 2.5-5.7 5.7-5.7M453.2 70.5c3.1 0 5.7 2.5 5.7 5.7M458.9 87.5c0-3.1 2.5-5.7 5.7-5.7M453.2 81.9c3.1 0 5.7 2.5 5.7 5.7M470.4 87.5c0-3.1 2.5-5.7 5.7-5.7M464.7 81.9c3.1 0 5.7 2.5 5.7 5.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M507.1 81.8l-57.7.1h-63.5l-42.8-.2M458.9 76.2c0 3.1-2.5 5.7-5.7 5.7M464.5 81.9c-3.1 0-5.7-2.5-5.7-5.7M556.3 81.6h55.1"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M458.8 76.2v36.4c0 2.4-1.5 3.7-3.4 3.7h-23.7c-1.8 0-2.8-.9-3.8-1.9-1-1-16.6-16.5-17.6-17.6-1.1-1.1-1.3-2-1.3-3.4V76.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M470.4 64.5v59.6c0 2.4-2.2 3.7-5 3.7H429c-2.7 0-4.3-.7-5.6-1.9-1.9-1.7-22.7-22.5-24-23.9-2-2.1-1.9-3.3-1.9-4.8V64.8M409 237.2v-33.5c0-1.2 0-2.1 1.2-3.2 1-.9 16.9-16.5 17.9-17.3 1-.8 2-1.5 3.8-1.5h23.6c1.9 0 3.4 1.1 3.4 3.1v72"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M470.5 237.2v-32.3-26c0-1.9-1.8-4.8-5.7-4.8h-35.7c-2.7 0-4.7.6-6.3 2.3-1.9 1.9-21.9 21.9-23.2 23.1-2 1.7-1.9 2.7-1.9 3.9v22.3M430.9 40.8l-16 8.1-14.8 8.8c-2.2 1.5-2.7 2.3-2.7 7.2M449 59.2c3.1 0 5.7-2.5 5.7-5.7 0 0 .3-3.5-2.6-5"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M436.8 40.8l16 8.1 14.9 8.8c2.1 1.5 2.7 2.3 2.7 7.2M458.3 52.1c7.1 4.2 20 7 27.1 7M409.4 52.2c-7.1 4.2-20 7-27.1 7M508.4 243c-465.3.2-445.8.2-452.1.2-4.8 0-7 3.2-7 5.7 0 3.8.4 5.8 2 9.7M343.2 231.6l184.6-.1"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M343.2 220.2l178.9-.1c3.1 0 5.7 2.5 5.7 5.7v24.8M374.9 261l10.5-4.5 17.7-10.2c5.2-3.1 6-3.1 6-9.1M304.2 243c3.1 0 5.8 2.8 5.8 5.9 0 0 0 2.7-2.7 4.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M290.7 261.3l9.1-3.8 19.3-11.2c.8-.5 5.7-3.3 5.7-3.3M244.4 243.1c3.1 0 5.8 2.8 5.8 5.9 0 0 0 2.7-2.7 4.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M230.9 261.3l9.1-3.8 19.3-11.2c.8-.5 5.7-3.3 5.7-3.3M326.2 243c-3.1 0-5.8 2.8-5.8 5.9 0 0 0 2.7 2.7 4.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M339.7 261.3l-9.1-3.8-19.3-11.2c-.8-.5-5.7-3.3-5.7-3.3M285.7 243c-3.1 0-5.8 2.8-5.8 5.9 0 0 0 2.7 2.7 4.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M299.2 261.3l-9.1-3.8-19.3-11.2c-.8-.4-5.7-3.3-5.7-3.3M192.3 243.1c-2.8 0-5.2 2.6-5.5 4.6-.4 2.4.3 4.8 2.5 6.1"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M204.9 261.3l-9.1-3.8s-10-5.9-13.8-8c-5-2.8-15.5-6.5-26-6.5M71.3 243.1c-5.6 0-8.5 2.3-8.6 5.3-.1 3 .5 6.7 2.1 9.8M68 94c1.7-1.6 3-3 3.4-3.4 2.8-2.8 5.1-2.9 6.9-2.9 1.7 0 5.8-1.1 5.8-5.5V51.5M617.1 76.1V50.8M343.2 177.3h9.9s7 .3 10.6-3.2c3.5-3.5 15.6-16.2 17.5-18.1 2.6-2.9 3.1-6.8.3-9.5-2.8-2.7-16.7-15.9-19.7-19-3.1-3.1-10-2.7-10-2.7h-8.6"
            />
            <path
              fill="#DCDDDE"
              fillRule="nonzero"
              d="M316.8 99.1l-102.8.1V77.3l102.8-.1v21.9M201.7 223h19.2v-17.7h-6.5v-25.4h-5.3v2c0 .7-.5 1.2-1.2 1.2h-1.6v.6h-.5v5.8h.5v2.3h-4.5l-.1 31.2M417 88.4v1.4l-3.6 3.3 18.3 18.1H448c3.1 0 5.7-2.5 5.7-5.7V88.4H417zm24.4 8.3c0 .6-.5 1.2-1.1 1.2h-3.1c-.3 0-.6-.1-.8-.3l-7.7-7.7c-.2-.2-.2-.4-.1-.6.1-.2.3-.3.5-.3h11.2c.6 0 1.1.5 1.1 1.1v6.6zM427.1 213.4l8.7-8.6c.4-.4.9-.6 1.4-.6h2.2c1.1 0 1.8.9 1.8 2v7h11.4c.6 0 1.1-.5 1.1-1.1V194l-2.6-3h-19.5l-17.8 17.8 3.5 3.6v.9l9.8.1M174.7 173h-22.6v-11.6h22.5l.1 11.6M139.8 77.4v9.4l-31.5.1v13.2h43.8l-.1-22.7h-12.2M212 106h-37.1V94.3H212V106M617 86.9h-79.9v8.3c1.2 0 3.3-.3 5 1.2 1.7 1.5 3.5 2 4.7 2 1.2 0 45.8.1 45.8.1.4-2.1 2.1-4.2 5-4.2 2.4 0 3.7 1.4 4.4 2.9l11.4-.1v-4.8c0-.4.1-.7.3-1l3.3-4.4M64.5 90.4l6.4 6.6 5.5 7.4v7.6l-12.6 9.6-5.3-.6-12.6-12 18.6-18.6"
            />
            <path
              fill="#DCDDDE"
              fillRule="nonzero"
              d="M506.9 122.947v-34.7h-30.4l.3 46.2h-54.2l-32.1-31.7v-12.7c0-1.3-.7-1.6-2.2-1.6h-34.4v11.2h24.2c.5 0 1.7.2 1.7 1.6v5.7c0 .3.1.7.6 1.2s36.4 37.7 36.4 37.7l30.4 1.2 45.2-2.2v-21.9h14.5M506.9 178.7v34.7h-30.4l.2-46.2h-54.2l-32 31.7v12.7c0 1.3-.7 1.6-2.2 1.6h-34.5v-11h24.4c1.2 0 1.9-.8 1.9-1.9v-5.4c0-.5.2-1 .9-1.7s35.6-37 35.6-37l30.6-1 45.2 1.6v21.9h14.5"
            />
            <path
              fill="#DCDDDE"
              fillRule="nonzero"
              d="M391.1 153.4V149c0-1-.7-2.1-2.2-3.6-.8-.8-13.6-13.6-24.7-24.8-3.5-3.5-7.6-3.4-10.3-3.5V98l45.9 46v13.8l-45.9 45.9v-18.8s6.4.3 10-3.3c1.8-1.8 13.7-13.8 25-25.1 1-.9 2.2-1.9 2.2-3.1"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M66.7 95.3c-1.1 1-1.7 2.5-1.7 4 0 1.1.3 2.1.9 3 .2.3 1.2 1.7 1.4 2.7.2.5.3 1 .3 1.6 0 2.9-2.1 5.2-5 5.2s-5.2-2.3-5.2-5.2c0-1.5.7-2.9 1.7-3.8 0 0 5.2-5.1 8.8-8.8M134.7 95.7V73M132.4 95.7h4.6M126.5 95.8V73M124.2 95.8h4.6M143 83.3h14.3M143 81l-.1 4.6M143 94.3h14.3M143 92.1v4.5M222.4 97.2V78.1M220.1 97.2h2.3l2.2.1M206.5 103.3V92.1M204.2 103.3h4.6M198.3 103.4V92.2M196 103.4h4.5M190.1 103.3V92.1M187.8 103.3h4.6M182.3 103l-9-9.1M180.7 104.6l1.6-1.6 1.6-1.6M566.8 83.4v12.9M564.5 96.3h4.6M575 83.4v12.9M572.8 96.3h4.5M444.3 93.4h12.6M444.2 95.7v-4.5M499.3 116.5h9.9M499.3 118.8v-4.6M499.3 108.2h9.8M499.3 110.4v-4.5M498.7 95l8.5-5M499.9 97l-1.2-2-1.1-1.9M485.5 101.9l-8.9-4.1M486.5 99.9l-.9 2.1-1 2M491.5 95.5v-9.8M493.8 95.5h-4.6M427.9 142.6v-9.9M430.2 142.6h-4.6M417.3 140.6l3.2-9.3M419.4 141.4l-2.1-.8-2.2-.7M436.1 142.6v-9.8M438.4 142.6h-4.6M445.1 142.6v-9.9M447.3 142.6h-4.5M453.3 142.6v-9.8M455.5 142.6H451M375.7 97.3v-9.9M377.9 97.3h-4.5M381.1 96.3l8.9-4.2M382.1 98.4l-1-2.1-.9-2M382 104.5l9.7-1.9M382.4 106.7l-.8-4.5M388.5 115.7l6.9-7M390.1 117.3l-1.6-1.6-1.6-1.6M401 128.1l6.9-7M402.6 129.7l-3.2-3.2M395.1 122.2l6.9-7M396.7 123.8l-1.6-1.6-1.6-1.6M406.9 133.9l6.9-7M408.5 135.5l-1.6-1.6-1.6-1.6M461.5 142.6v-9.9M463.8 142.6h-4.6M469.7 142.5v-9.8M472 142.5h-4.5M414.7 162.1l5 8.4M416.6 160.9l-1.9 1.2-2 1.1M426.5 159.3v9.8M428.8 159.3h-4.5M435.7 158.7v9.8M438 158.6l-2.3.1h-2.3M376.2 205.9v9.9M378.5 205.9h-4.6M407.3 168.6l7 6.8M408.9 166.9l-1.6 1.7-1.6 1.6M401.5 174.5l7 6.8M403 172.8l-1.6 1.7-1.5 1.6M395.6 180.4l7.1 6.8M397.2 178.7l-1.6 1.7-1.6 1.6M389.2 186.9l7 6.9M390.7 185.3l-3.1 3.2M382.8 197.4l9.6 2.5M383.4 195.2l-.6 2.2-.5 2.2M382.7 205.1l7.1 6.9M384.3 203.5l-1.6 1.6-1.5 1.6M445 158.7v9.9M447.3 158.7h-4.6M453.3 158.8v9.8M455.6 158.7H451M461.6 158.8v9.8M463.9 158.8h-4.6M500.2 205.8l5.6 8M498.3 207.1l1.9-1.3 1.8-1.3M499.5 199.9l9.3 3.3M498.7 202l.8-2.1.8-2.1M499.4 193.5h9.9M499.4 195.8v-4.5M499.4 185.3h9.8M499.3 187.6V183M485.9 173.3h-9.8M486 175.6l-.1-4.5M486.6 182.8h-9.8M486.6 185.1v-4.6M487.8 207.5l-8.9 4.2M488.8 209.6l-2-4.1M486.7 192.8h-9.9M486.7 195v-4.5M487.2 200.9l-9.7 1.7M487.6 203.1l-.4-2.2-.4-2.2M469.9 158.8v9.9M472.1 158.8h-4.5M493.9 206.3v9.9M496.2 206.3h-4.5M485.4 95.9l-5.7-8M487.3 94.6l-1.9 1.3-1.8 1.4M486.2 126.5h-9.7M486.2 128.8v-4.6M486 116.8h-9.7M486 119.1v-4.5M485.9 107.7h-9.7M485.9 110v-4.6M499.2 100.8h9.8M499.2 103.1v-4.6M218.9 219.1h-6.3M218.8 221.4l.1-4.6M210.6 219.1h-6.2M204.4 221.4v-4.5M210.6 214.1h-6.2M204.4 216.4v-4.5M210.6 209.1h-6.2M204.4 211.4v-4.5M210.6 204.1h-6.2M204.4 206.4v-4.5M210.6 199.2h-6.2M204.4 201.5V197M210.6 194.2h-6.2M204.4 196.5V192M218.8 214.1h-6.2M218.8 216.4v-2.3l.1-2.2M218.8 209.2h-6.2M218.8 211.5l.1-4.6M158 159.9v11M160.3 170.9h-4.6M169.3 159.9v11M171.6 170.9H167M413.6 205.1l12.1 5.6M426.7 208.6l-1.9 4.1M421.7 196.7l9 9M432.3 204.1l-1.6 1.6-1.6 1.6M429.1 189.2l7.3 11.1M438.3 199.1l-1.9 1.3-1.9 1.2M442.9 187.1l-2.2 13.2M442.9 200.6l-2.2-.3-2.2-.4M456 196.3l-11.7 5.4M443.4 199.7l.9 2 1 2.1M456.6 208.5h-12.2M444.3 210.8l.1-4.6M456.7 106.3l-12.5-6.1M443.2 102.2l1-2 1-2M423.2 103.8l7.4-7.5M432.2 97.9l-1.6-1.6-1.6-1.6M414.6 96.6l11-5.2M426.6 93.4l-2-4.1M430 111.4l6.2-9.8M438.1 102.8l-1.9-1.2-1.9-1.2M442.8 113.6l-2.2-11.9M438.4 102.1l2.2-.4 2.2-.4M583.2 83.4v12.9M581 96.3h4.5M591 95.3l6.2-10.6M593 96.4l-2-1.1-1.9-1.2M231 97.2V78.1M228.7 97.2h4.6M239.6 97.2V78.1M237.3 97.2h4.6M248.2 97.2V78.1M246 97.2h4.5M256.9 97.2V78.1M254.6 97.2h4.5M267.2 97.2V78.1M264.9 97.2h4.6M275.8 97.2V78M273.5 97.2h4.6M284.5 97.2V78M282.2 97.2h4.5M293.1 97.1V78M290.8 97.1h2.3l2.2.1M301.7 97.2V78M299.4 97.2h4.6M310.3 97.2V78M308 97.2h4.6"
            />
            <path
              fill="#646565"
              fillRule="nonzero"
              d="M529.4 261v6.7l-481.9.5-.1-6.6 482-.6"
            />
            <path
              stroke="#DCDDDE"
              strokeDasharray="3.4387,2.9014"
              strokeWidth=".269"
              d="M48.7 264.9l474.2-.6"
            />
            <path
              fill="#606161"
              fillRule="nonzero"
              d="M618.6 33.9v6.7L69 41.4l.1-6.8 549.5-.7"
            />
            <path
              stroke="#DCDDDE"
              strokeDasharray="3.4387,2.9014"
              strokeWidth=".269"
              d="M69.6 38l542.3-.7"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M69.6 37.5h5.1v.2h-5.1v-.2M69.6 37.1h5.1v.3h-5.1v-.3M69.6 38.2h5.1v.3h-5.1v-.3M69.6 38.6h5.1v.2h-5.1v-.2M69.6 39h5.1v.2h-5.1V39M69.6 39.3h5.1v.3h-5.1v-.3M69.6 39.7h5.1v.2h-5.1v-.2M69.6 40.1h5.1v.2h-5.1v-.2M69.6 40.5h5.1v.2h-5.1v-.2M69.6 40.8h5.1v.3h-5.1v-.3M69.6 36.8h5.1v.2h-5.1v-.2M69.6 36.4h5.1v.2h-5.1v-.2M69.6 36h5.1v.3h-5.1V36M69.6 35.6h5.1v.3h-5.1v-.3M69.6 35.3h5.1v.2h-5.1v-.2M69.6 34.9h5.1v.2h-5.1v-.2M612.9 36.8h5.2v.2h-5.2v-.2M612.9 36.4h5.2v.2h-5.2v-.2M612.9 37.5h5.2v.2l-5.2.1v-.3M612.9 37.9h5.2v.2h-5.2v-.2M612.9 38.3h5.2v.2h-5.2v-.2M612.9 38.6h5.2v.3h-5.2v-.3M612.9 39h5.2v.2h-5.2V39M612.9 39.4h5.2v.2h-5.2v-.2M612.9 39.7h5.2v.3h-5.2v-.3M612.9 40.1h5.2v.2h-5.2v-.2M612.9 36h5.2v.3h-5.2V36M612.9 35.7h5.2v.2h-5.2v-.2M612.9 35.3h5.2v.2h-5.2v-.2M612.9 34.9h5.2v.3h-5.2v-.3M612.9 34.6h5.2v.2h-5.2v-.2M612.9 34.2h5.2v.2h-5.2v-.2M523.7 263.8h5.1v.3h-5.1v-.3M523.7 263.5h5.1v.2h-5.1v-.2M523.7 264.6h5.1v.2h-5.1v-.2M523.7 264.9h5.1v.3h-5.1v-.3M523.7 265.3h5.1v.2l-5.1.1v-.3M523.7 265.7h5.1v.2h-5.1v-.2M523.7 266.1h5.1v.2h-5.1v-.2M523.7 266.4h5.1v.3h-5.1v-.3M523.7 266.8h5.1v.2h-5.1v-.2M523.7 267.2h5.1v.2h-5.1v-.2M523.7 263.1h5.1v.2h-5.1v-.2M523.7 262.7h5.1v.3h-5.1v-.3M523.7 262.4h5.1v.2h-5.1v-.2M523.7 262h5.1v.2h-5.1v-.2M523.7 261.6h5.1v.3h-5.1v-.3M523.7 261.3h5.1v.2h-5.1v-.2M458.8 263.3h2.6v.2h-2.6v-.2M458.8 262.8h2.6v.3h-2.6v-.3M458.8 265.8h2.6v.2h-2.6v-.2M458.8 265.4h2.6v.2h-2.6v-.2M441.9 265.4h2.6v.2h-2.6v-.2M441.9 263.1h2.6v.2h-2.6v-.2M424.9 265.4h2.6v.2h-2.6v-.2M424.9 263.1h2.6v.3h-2.6v-.3M492.9 263.2h2.6v.2h-2.6v-.2M492.9 262.8h2.6v.2h-2.6v-.2M492.9 262.4h2.6v.2h-2.6v-.2M492.9 265.8h2.6v.2h-2.6v-.2M492.9 265.4h2.6v.2h-2.6v-.2M492.9 266.2h2.6v.2h-2.6v-.2M509.8 263.2h2.6v.2h-2.6v-.2M509.8 262.8h2.6v.2h-2.6v-.2M509.8 262.4h2.6v.2h-2.6v-.2M509.9 265.8h2.6v.2h-2.6v-.2M509.9 265.4h2.6v.2h-2.6v-.2M509.9 266.2h2.6v.2h-2.6v-.2M479 265.4h5.3v1.2H479v-1.2M479 262.2h5.3v1.2H479v-1.2M548 36.2h2.6v.3H548v-.3M548 35.8h2.6v.3H548v-.3M548 38.8h2.6v.2H548v-.2M548 38.4h2.6v.2H548v-.2M531.1 38.4h2.6v.2h-2.6v-.2M531.1 36.1h2.6v.2h-2.6v-.2M514.1 38.4h2.6v.3h-2.6v-.3M514.1 36.1h2.6v.3h-2.6v-.3M582.1 36.2h2.6v.2h-2.6v-.2M582.1 35.8l2.6-.1v.3h-2.6v-.2M582.1 35.3h2.6v.3h-2.6v-.3M582.1 38.7h2.6v.3h-2.6v-.3M582.1 38.3h2.6v.2l-2.6.1v-.3M582.1 39.1h2.6v.3h-2.6v-.3M599 36.1h2.6v.3H599v-.3M599 35.7h2.6v.3H599v-.3M599 35.3h2.6v.2l-2.6.1v-.3M599.1 38.7h2.6v.2h-2.6v-.2M599.1 38.3h2.6v.2h-2.6v-.2M599.1 39.1h2.6v.3h-2.6v-.3M568.2 38.4h5.3v1.2h-5.3v-1.2M568.2 35.2h5.3v1.2h-5.3v-1.2M118.1 263.7h-2.6v.2h2.6v-.2M118.1 263.2h-2.6v.3h2.6v-.3M118.1 266.2h-2.6v.2h2.6v-.2M118.1 265.8h-2.6v.2h2.6v-.2M135 265.8h-2.6v.2h2.6v-.2M135 263.5h-2.6v.2h2.6v-.2M152 265.8h-2.6v.2h2.6v-.2M152 263.5h-2.6v.2h2.6v-.2M84 263.6h-2.6v.3H84v-.3M84 263.2h-2.6v.2H84v-.2M84 262.8h-2.6v.2H84v-.2M83.9 266.2h-2.6v.2h2.6v-.2M83.9 265.8h-2.6v.2h2.6v-.2M83.9 266.6h-2.6v.2h2.6v-.2M67 263.6h-2.6v.3H67v-.3M67 263.2h-2.6v.2H67v-.2M67 262.8h-2.6v.2H67v-.2M67 266.2h-2.6v.2H67v-.2M67 265.8h-2.6v.2H67v-.2M67 266.6h-2.6v.2H67v-.2M97.8 265.8h-5.2v1.2h5.2v-1.2M97.8 262.6h-5.2v1.2h5.2v-1.2M139.6 36.7H137v.3h2.6v-.3M139.6 36.3H137v.3h2.6v-.3M139.6 39.3H137v.2h2.6v-.2M139.6 38.9H137v.2h2.6v-.2M156.5 38.9h-2.6v.2h2.6v-.2M156.5 36.6h-2.6v.2h2.6v-.2M173.5 38.9h-2.6v.2h2.6v-.2M173.5 36.6h-2.6v.2h2.6v-.2M105.5 36.7h-2.6v.2h2.6v-.2M105.5 36.3h-2.6v.2h2.6v-.2M105.5 35.9h-2.6v.2h2.6v-.2M105.5 39.3h-2.6v.2h2.6v-.2M105.5 38.9h-2.6v.2h2.6v-.2M105.5 39.7h-2.6v.2h2.6v-.2M88.5 36.7h-2.6v.2h2.6v-.2M88.5 36.3h-2.6v.2h2.6v-.2M88.5 35.9h-2.6v.2h2.6v-.2M88.5 39.3h-2.6v.2h2.6v-.2M88.5 38.9h-2.6v.2h2.6v-.2M88.5 39.7h-2.6v.2h2.6v-.2M119.4 38.9h-5.3v1.2h5.2l.1-1.2M119.3 35.7h-5.2v1.2h5.2v-1.2M48.1 264.4h5.1v.3h-5.1v-.3M48.1 264.1h5.1v.2h-5.1v-.2M48.1 265.2h5.1v.2h-5.1v-.2M48.1 265.6l5.1-.1v.3h-5.1v-.2M48.1 265.9h5.1v.3h-5.1v-.3M48.1 266.3h5.1v.2h-5.1v-.2M48.1 266.7h5.1v.2h-5.1v-.2M48.1 267h5.1v.3h-5.1v-.3M48.1 267.4h5.1v.2h-5.1v-.2M48.1 267.8h5.1v.2h-5.1v-.2M48.1 263.7h5.1v.2h-5.1v-.2M48.1 263.3h5.1v.3h-5.1v-.3M48.1 263h5.1v.2h-5.1v-.2M48.1 262.6h5.1v.2h-5.1v-.2M48.1 262.2h5.1v.3h-5.1v-.3M48.1 261.9h5.1v.2h-5.1v-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M36.4 38.1l-1.8 1.7v.4l2.1-2.1-2.1-2.2v.4zM66.6 41.9v.3l2.5-2.4v-.4zM66.6 33.9v.3l2.5 2.5-.1-.4z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M63.2 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M63.2 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M63.2 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M59.8 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M59.8 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M59.8 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M56.4 41.9v.3l4.2-4.1-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M56.4 41.9v.3l4.2-4.1-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M56.4 41.9v.3l4.2-4.1-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M53 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M53 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M53 41.9v.3l4.2-4.1-4.2-4.2v.3l3.8 3.9-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M49.6 41.9v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M49.6 41.9v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M49.6 41.9v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M46.2 41.9v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M46.2 41.9v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M46.2 41.9v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M42.8 41.9v.4l4.1-4.2-4.1-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M42.8 41.9v.4l4.1-4.2-4.1-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M42.8 41.9v.4l4.1-4.2-4.1-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M39.4 41.9v.4l4.1-4.2-4.1-4.2-.1.4 3.9 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M39.4 41.9v.4l4.1-4.2-4.1-4.2-.1.4 3.9 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M39.4 41.9v.4l4.1-4.2-4.1-4.2-.1.4 3.9 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M35.9 41.9v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8-3.9 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M35.9 41.9v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M35.9 41.9v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8-3.9 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M36.4 38.1l-1.8 1.7v.4l2.1-2.1-2.1-2.2v.4l1.8 1.8M66.6 41.9v.3l2.5-2.4v-.4l-2.5 2.5M66.6 33.9v.3l2.5 2.5-.1-.4-2.4-2.4"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M651.3 37.2l1.8 1.8v.4l-2.1-2.2 2.1-2.1v.4zM621.1 41.1v.4l-2.5-2.5v-.3zM621 33.1l.1.4-2.5 2.4v-.4z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M624.5 41.1v.3l-4.2-4.1 4.1-4.2.1.4-3.9 3.8 3.9 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M624.5 41.1v.3l-4.2-4.1 4.1-4.2.1.4-3.9 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M624.5 41.1v.3l-4.2-4.1 4.1-4.2.1.4-3.9 3.8 3.9 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M627.9 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.9 3.9 3.9 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M627.9 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.9 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M627.9 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.9 3.9 3.9 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M631.3 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M631.3 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M631.3 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M634.7 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M634.7 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M634.7 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M638.1 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M638.1 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M638.1 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M641.5 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M641.5 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M641.5 41.1v.3l-4.2-4.1 4.2-4.2v.3l-3.8 3.9 3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M644.9 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8 3.8 3.9"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M644.9 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M644.9 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8 3.8 3.9"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M648.3 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8 3.8 3.9"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M648.3 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M648.3 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8 3.8 3.9"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M651.7 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8 3.8 3.9"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M651.7 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M651.7 41.1v.3l-4.2-4.2 4.2-4.1v.3l-3.8 3.8 3.8 3.9"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M651.3 37.2l1.8 1.8v.4l-2.1-2.2 2.1-2.1v.4l-1.8 1.7M621.1 41.1v.4l-2.5-2.5v-.3l2.5 2.4M621 33.1l.1.4-2.5 2.4v-.4l2.4-2.4M536 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M536 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M536 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M539.4 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M539.4 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M539.4 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M542.8 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M542.8 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M542.8 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M546.2 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M546.2 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M546.2 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M549.6 260.9v-.4l-4.1 4.2 4.1 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M549.6 260.9v-.4l-4.1 4.2 4.1 4.2v-.4l-3.8-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M549.6 260.9v-.4l-4.1 4.2 4.1 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M553.1 260.9v-.4l-4.2 4.2 4.1 4.2.1-.4-3.9-3.8 3.9-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M553.1 260.9v-.4l-4.2 4.2 4.1 4.2.1-.4-3.9-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M553.1 260.9v-.4l-4.2 4.2 4.1 4.2.1-.4-3.9-3.8 3.9-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M556.5 260.9v-.4l-4.2 4.2 4.1 4.2.1-.4-3.9-3.8 3.9-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M556.5 260.9v-.4l-4.2 4.2 4.1 4.2.1-.4-3.9-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M556.5 260.9v-.4l-4.2 4.2 4.1 4.2.1-.4-3.9-3.8 3.9-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M559.9 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.9-3.8 3.9-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M559.9 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.9-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M559.9 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.9-3.8 3.9-3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M563.3 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M563.3 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M563.3 260.9v-.4l-4.2 4.2 4.2 4.2v-.4l-3.8-3.8 3.8-3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M532.6 268.9v-.4l-3.2-3.1v.3zM532.6 260.9v-.4l-3.2 3.2v.3zM562.9 264.7l1.1-1.2v-.4l-1.5 1.6 1.5 1.5v-.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M532.6 268.9v-.4l-3.2-3.1v.3l3.2 3.2M532.6 260.9v-.4l-3.2 3.2v.3l3.2-3.1M562.9 264.7l1.1-1.2v-.4l-1.5 1.6 1.5 1.5v-.3l-1.1-1.2M41.8 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M41.8 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M41.8 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M38.4 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M38.4 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M38.4 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M35 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M35 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M35 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M31.6 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M31.6 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M31.6 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M28.2 268.7v.4l4.1-4.2-4.1-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M28.2 268.7v.4l4.1-4.2-4.1-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M28.2 268.7v.4l4.1-4.2-4.1-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M24.7 268.7v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8-3.9 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M24.7 268.7v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M24.7 268.7v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8-3.9 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M21.3 268.7v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8-3.9 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M21.3 268.7v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M21.3 268.7v.4l4.2-4.2-4.1-4.2-.1.4 3.9 3.8-3.9 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M17.9 268.7v.4l4.2-4.2-4.2-4.2v.4l3.9 3.8-3.9 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M17.9 268.7v.4l4.2-4.2-4.2-4.2v.4l3.9 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M17.9 268.7v.4l4.2-4.2-4.2-4.2v.4l3.9 3.8-3.9 3.8"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M14.5 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M14.5 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M14.5 268.7v.4l4.2-4.2-4.2-4.2v.4l3.8 3.8-3.8 3.8"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M45.2 268.7v.4l2.2-2.3v-.3l-2.2 2.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M45.2 268.7v.4l2.2-2.3v-.3z"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M45.2 260.7v.4l2.2 2.2v-.4l-2.2-2.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M45.2 260.7v.4l2.2 2.2v-.4z"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M14.9 264.9l-1.9 1.9v.3l2.3-2.2-2.3-2.3v.4l1.9 1.9"
            />
            <path
              stroke="#575759"
              strokeWidth=".269"
              d="M14.9 264.9l-1.9 1.9v.3l2.3-2.2-2.3-2.3v.4z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M45.2 268.7v.4l2.2-2.3v-.3l-2.2 2.2M45.2 260.7v.4l2.2 2.2v-.4l-2.2-2.2M14.9 264.9l-1.9 1.9v.3l2.3-2.2-2.3-2.3v.4l1.9 1.9"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M47.4 269.7H13v-9.6h31.7V258"
            />
            <path
              stroke="#575759"
              strokeWidth=".501"
              d="M532.3 271.9v-3h31.6v-9h-31.5v-1.8M621.5 44.4v-2.5h31.6v-9.3l-34.4.1"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M69 33.2H34.5l.1 9.7 31.5-.1v1.9"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M456.9 154.6v5.2h.9l1-5.2h-1.9M448.5 154.5v5.2h.9l.9-5.2h-1.8M439.9 154.3v5.2h.9l.9-5.1-1.8-.1M431.4 154.6v5.2h.9l1-5.1-1.9-.1M421.2 155.5v5.2h1l.9-5.1-1.9-.1"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              stroke="#000"
              d="M398.338 162.055l-3.677-3.677-.707.707 2.97 4.243 1.414-1.273M396.963 141.877l-3.63 3.723.716.698 4.205-3.023-1.29-1.398M392.046 136.825l-3.396 3.938.757.653 4.012-3.275-1.373-1.316M401.912 170.982l3.808 3.54.681-.732-3.122-4.132-1.367 1.324M408.82 164.159l3.996 3.327.64-.768-3.343-3.955-1.293 1.396M403.276 132.825l3.63-3.723-.716-.698-4.205 3.023 1.29 1.398M410.202 139.811l3.723-3.63-.699-.716-4.279 2.916 1.255 1.43"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M465.4 155v5.2h.9l.9-5.2h-1.8M431.3 147.6v-5.2h-.9l-.9 5.2h1.8M439.9 147.6v-5.3h-1l-.9 5.2 1.9.1M448.4 147.9v-5.2h-1l-.9 5.1 1.9.1M456.8 147.6v-5.2h-.9l-.9 5.2h1.8M473.7 146.5v-5.2h-1l-.9 5.2h1.9M465.3 147.2V142h-.9l-.9 5.1 1.8.1M421.2 146.6v-5.2h-1l-.9 5.2h1.9M531.7 157l-7.2-.9h-7.2v-1.3h7.3l7.2.9-.1 1.3"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M514.9 165.6v-28.9h-19.5V99h-7v35.9l-13.7 1.8v9.1c-18.7 2.1-52.5 1.1-58.1.1l-20.1-19.7-7.5 7.8 10.9 10.9v15.6l-9.2 9.5 6.5 6.1 19-19.3c5.6-1 40.1-2.2 58.7-.1v9.1l13.8 1.9v35.9h7v-24.1h1.5V175h4v-1.6h-4v-7.6l17.7-.2M531.7 144.9l-7.2.9h-7.2v1.3h7.3l7.2-.9-.1-1.3"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M523.4 145.5l17.6-2.3-1.9-14.2s-4.5-2.1-9.5-1.4c-4.8.7-8 2.9-8 2.9l1.8 15M541 158.5l-17.6-2-1.8 15s4.1 2.6 9.1 3.2c4.9.5 8.6-1.9 8.6-1.9l1.7-14.3M524.5 146.4l-4.4.1c-.2.4-.3 1.6-.4 3.1h5.2c-.1-1.6-.2-2.9-.4-3.2M524.9 150.3h-5.2v1.5h5.2v-1.5M520.1 155.5l4.4-.1c.2-.4.3-1.5.4-2.8h-5.2c0 1.5.2 2.7.4 2.9M494.4 190.1h3.4v-.7h-3.4v.7M494.4 198.1h3.4v-.7h-3.4v.7M494.4 202.9h3.5v-.7h-3.5v.7M486.6 204.4l3-1.8-.4-.7-3 1.8.4.7"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M494.2 203.1l1.5 3.1.7-.3-1.6-3.1-.6.3M489.7 206.7h.9v-5.1h-.9v5.1M486.5 198.1h3.5v-.7h-3.5v.7M485.2 189.3h4.8v-.9h-4.8v.9M485.2 179.1h4.8v-1h-4.8v1M486.4 170.1h3.6v-1h-3.6v1M490.1 112.8h-5v1.1h5v-1.1M494.6 95.4h-.8v4.1h.8v-4.1M488.5 95.9l-.6.4 2.1 3.4.7-.4-2.2-3.4M490.1 123.1h-5v1h5v-1M490.1 103.9h-3.8v1.1h3.8v-1.1"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              d="M490.1 99.1h-3.8v1h3.8v-1M497.8 103.9H494v.7h3.8v-.7M497.7 98l-3.4 1.8.3.6 3.4-1.8-.3-.6M497.8 110.5H494v.7h3.8v-.7M497.8 118.5H494v.7h3.8v-.7"
            />
            <path stroke="#575759" strokeWidth=".284" d="M337.4 70.7v-7.3" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M66.4 251.1v-.7h-6.2v.7h6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M60.2 250.4h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M66.4 249.9v-.8l-6.2.1v.7h6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M60.2 249.1h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M64.7 251.5h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M64.7 251.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M62.4 251.5h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M62.4 251.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M60.2 251.5H62v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M60.2 251.5H62v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M64.7 252.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M64.7 252.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M62.4 252.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M62.4 252.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M60.2 252.6H62v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M60.2 252.6H62v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M124.6 252.4v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M118.3 251.7h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M124.6 251.2v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M118.3 250.5h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M122.8 252.8h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M122.8 252.8h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M120.5 252.8h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M120.5 252.8h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M118.3 252.8h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M118.3 252.8h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M122.8 253.9h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M122.8 253.9h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M120.5 253.9h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M120.5 253.9h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M118.3 253.9h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M118.3 253.9h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M188.7 249.2h1.7v.7h-1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M188.7 249.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M186.4 249.2h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M186.4 249.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M188.7 250.3h1.7v.7h-1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M188.7 250.3h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M186.4 250.3h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M186.4 250.3h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M190.4 248.1h-6.3l-2.3 5.2.7.3 2-4.8h5.9v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M190.4 248.1h-6.3l-2.3 5.2.7.3 2-4.8h5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M190.4 246.9h-7.1l-2.6 6 .7.3 2.4-5.6h6.6v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M190.4 246.9h-7.1l-2.6 6 .7.3 2.4-5.6h6.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M185.9 249.2h-1.1l-.2.5.6.2h.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M185.9 249.2h-1.1l-.2.5.6.2h.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M183.7 251.7l.7-1.6.7.3-.7 1.6-.7-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M185.04 250.35l-.702 1.657-.92-.39.702-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M182.8 253.8l.7-1.6.7.2-.7 1.7-.7-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M184.16 252.382l-.701 1.658-.921-.39.7-1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M184.7 252.2l.7-1.7.7.3-.7 1.6-.7-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M186.115 250.784l-.702 1.657-.92-.39.7-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M183.9 254.2l.7-1.6.6.3-.7 1.6-.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M183.9 254.2l.7-1.6.6.3-.7 1.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M323.5 249.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M323.5 249.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M321.2 249.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M321.2 249.1h1.8v1h-1.8z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M323.5 250.2h1.8v1h-1.8z" />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M323.5 250.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M321.2 250.2h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M321.2 250.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M325.3 248h-6.4l-2.2 5.3.6.3 2.1-4.8h5.9v-.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M325.3 248h-6.4l-2.2 5.3.6.3 2.1-4.8h5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M325.3 246.8h-7.2l-2.6 6 .7.3 2.4-5.6h6.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M325.3 246.8h-7.2l-2.6 6 .7.3 2.4-5.6h6.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M320.8 249.1H319.6l-.2.5.6.2.1.1v-.1h.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M320.8 249.1H319.6l-.2.5.6.2.1.1v-.1h.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M318.6 251.7l.7-1.7.6.3-.7 1.6-.6-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M319.932 250.284l-.701 1.658-.921-.39.701-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M317.7 253.7l.7-1.6.6.3-.7 1.6-.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M319.028 252.417l-.698 1.66-.922-.388.698-1.66z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M319.6 252.1l.7-1.6.6.2-.7 1.7-.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M320.916 250.676l-.702 1.658-.92-.39.7-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M318.7 254.2l.7-1.7.6.3-.7 1.6-.6-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M320.044 252.85l-.704 1.656-.92-.39.704-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M282 249.1h1.8v.7H282v-.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M282 249.1h1.8v1H282z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M279.7 249.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M279.7 249.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M282 250.3h1.8v.6H282v-.6"
            />
            <path stroke="#575759" strokeWidth=".1" d="M282 250.3h1.8v1H282z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M279.7 250.3h1.8v.6h-1.8v-.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M279.7 250.3h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M283.8 248h-6.4l-2.2 5.3.7.3 2-4.8h5.9v-.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M283.8 248h-6.4l-2.2 5.3.7.3 2-4.8h5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M283.8 246.8h-7.2l-2.6 6 .7.3 2.4-5.5h6.7v-.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M283.8 246.8h-7.2l-2.6 6 .7.3 2.4-5.5h6.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M279.3 249.1H278.1l-.2.5.6.2.1.1v-.1h.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M279.3 249.1H278.1l-.2.5.6.2.1.1v-.1h.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M277.1 251.7l.7-1.7.6.3-.7 1.7-.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M278.467 250.307l-.703 1.657-.92-.39.702-1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M276.2 253.8l.7-1.7.6.3-.7 1.6-.6-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M277.51 252.42l-.703 1.658-.92-.39.701-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M278.1 252.1l.7-1.6.6.2-.7 1.7-.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M278.1 252.1l.7-1.6.6.2-.7 1.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M277.2 254.2l.7-1.7.6.3-.7 1.7-.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M277.2 254.2l.7-1.7.6.3-.7 1.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M247.5 249.2h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M245.7 249.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M249.8 249.2H248v.7h1.8v-.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M248 249.2h1.8v1H248z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M247.5 250.3h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M245.7 250.3h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M249.8 250.3H248v.7h1.8v-.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M248 250.3h1.8v1H248z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M245.8 248h6.3l2.3 5.3-.7.3-2.1-4.8h-5.8v-.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M245.8 248h6.3l2.3 5.3-.7.3-2.1-4.8h-5.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M245.8 246.8h7.1l2.6 6-.7.3-2.4-5.5h-6.6v-.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M245.8 246.8h7.1l2.6 6-.7.3-2.4-5.5h-6.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M250.2 249.2h1.2l.2.4-.6.3H250.2v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M250.2 249.2h1.2l.2.4-.6.3H250.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M252.5 251.7l-.7-1.6-.7.2.7 1.7.7-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M251.718 250.065l.703 1.657-.92.39-.703-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M253.3 253.8l-.7-1.7-.6.3.7 1.6.6-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M252.673 252.15l.7 1.658-.922.388-.7-1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M251.4 252.1l-.7-1.6-.6.3.7 1.6.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M250.757 250.49l.703 1.658-.92.39-.703-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M252.3 254.2l-.7-1.6-.6.2.7 1.7.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M252.3 254.2l-.7-1.6-.6.2.7 1.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M306.7 249.1h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M304.9 249.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M308.9 249.1h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M307.1 249.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M306.7 250.2h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M304.9 250.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M308.9 250.2h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M307.1 250.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M304.9 248h6.4l2.2 5.3-.7.3-2-4.8h-5.9v-.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M304.9 248h6.4l2.2 5.3-.7.3-2-4.8h-5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M304.9 246.8h7.1l2.6 6-.7.3-2.4-5.5h-6.6v-.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M304.9 246.8h7.1l2.6 6-.7.3-2.4-5.5h-6.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M309.4 249.1h1.1l.2.5-.5.2-.1.1v-.1h-.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M309.4 249.1h1.1l.2.5-.5.2-.1.1v-.1h-.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M311.6 251.7l-.7-1.7-.6.3.7 1.6.6-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M310.91 249.977l.704 1.657-.92.39-.704-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M312.5 253.7l-.7-1.6-.7.3.7 1.6.7-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M311.806 252.093l.7 1.658-.92.39-.701-1.659z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M310.6 252.1l-.7-1.6-.7.2.7 1.7.7-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M309.867 250.452l.704 1.657-.92.391-.704-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M311.5 254.2l-.7-1.7-.7.3.7 1.7.7-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M311.5 254.2l-.7-1.7-.7.3.7 1.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M319.1 52.9h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M317.3 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M321.4 52.9h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M319.6 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M319.1 51.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M317.3 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M321.4 51.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M319.6 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M317.4 54h6.3l2.3-5.3-.7-.3-2.1 4.9h-5.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M317.4 54h6.3l2.3-5.3-.7-.3-2.1 4.9h-5.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M317.4 55.2h7.1l2.6-6-.7-.3-2.4 5.6h-6.6v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M317.4 55.2h7.1l2.6-6-.7-.3-2.4 5.6h-6.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M321.8 52.9h1.2l.2-.5-.6-.2H321.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M321.8 52.9h1.2l.2-.5-.6-.2H321.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M324.1 50.4l-.7 1.6-.7-.3.7-1.6.7.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M322.726 51.72l.702-1.657.92.39-.702 1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M324.9 48.3l-.7 1.6-.6-.2.7-1.7.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M323.575 49.642l.7-1.658.922.39-.701 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M323 49.9l-.6 1.7-.7-.3.7-1.6.6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M321.763 51.287l.7-1.658.921.389-.7 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M323.9 47.9l-.7 1.6-.6-.3.7-1.6.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M322.62 49.186l.701-1.658.922.389-.7 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M273.6 52.9h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M271.8 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M275.9 52.9h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M274.1 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M273.6 51.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M271.8 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M275.9 51.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M274.1 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M271.8 54h6.4l2.2-5.2-.7-.3-2 4.8h-5.9v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M271.8 54h6.4l2.2-5.2-.7-.3-2 4.8h-5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M271.8 55.2h7.2l2.6-6-.7-.3-2.4 5.6h-6.7v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M271.8 55.2h7.2l2.6-6-.7-.3-2.4 5.6h-6.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M276.3 52.9H277.5l.2-.5-.6-.2H276.3v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M276.3 52.9H277.5l.2-.5-.6-.2H276.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M278.5 50.4l-.7 1.6-.6-.3.7-1.6.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M277.189 51.71l.701-1.658.921.39-.701 1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M279.4 48.3l-.7 1.6-.6-.2.7-1.7.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M278.044 49.622l.701-1.658.921.39-.7 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M277.5 49.9l-.7 1.7-.6-.3.7-1.6.6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M276.224 51.298l.7-1.658.92.389-.7 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M278.4 47.9l-.7 1.6-.6-.3.7-1.6.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M277.04 49.271l.7-1.658.921.389-.7 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M355.2 52.9h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M355.2 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M352.9 52.9h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M352.9 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M355.2 51.8h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M355.2 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M352.9 51.8h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M352.9 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M356.9 54h-6.3l-2.3-5.3.7-.3 2.1 4.8h5.8v.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M356.9 54h-6.3l-2.3-5.3.7-.3 2.1 4.8h5.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M356.9 55.2h-7.1l-2.6-6 .7-.3 2.4 5.6h6.6v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M356.9 55.2h-7.1l-2.6-6 .7-.3 2.4 5.6h6.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M352.5 52.9H351.3l-.2-.5.6-.2.1-.1v.1h.7v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M352.5 52.9H351.3l-.2-.5.6-.2.1-.1v.1h.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M350.2 50.3l.7 1.7.7-.3-.7-1.6-.7.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M350.965 51.985l-.704-1.657.92-.391.704 1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M349.4 48.3l.7 1.6.6-.3-.7-1.6-.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M350.065 49.97l-.702-1.658.92-.39.703 1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M351.3 49.9l.7 1.7.6-.3-.7-1.7-.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M352 51.572l-.699-1.659.922-.388.7 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M350.4 47.8l.7 1.7.6-.3-.7-1.6-.6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M351.07 49.43l-.702-1.657.921-.39.701 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M266.8 52.9h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M266.8 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M264.5 52.9h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M264.5 52.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M266.8 51.8h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M266.8 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M264.5 51.8h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M264.5 51.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M268.5 54h-6.3l-2.3-5.2.7-.3 2.1 4.8h5.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M268.5 54h-6.3l-2.3-5.2.7-.3 2.1 4.8h5.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M268.5 55.2l-7.1.1-2.6-6.1.7-.3 2.4 5.6h6.6v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M268.5 55.2l-7.1.1-2.6-6.1.7-.3 2.4 5.6h6.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M264.1 52.9h-1.2l-.2-.5.6-.2H264.1v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M264.1 52.9h-1.2l-.2-.5.6-.2H264.1z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M261.8 50.4l.7 1.6.7-.2-.7-1.7-.7.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M262.512 52.03l-.705-1.657.92-.391.705 1.656z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M261 48.3l.7 1.7.6-.3-.7-1.7-.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M261.621 50.01l-.703-1.656.921-.39.703 1.656z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M262.8 49.9l.7 1.7.7-.3-.7-1.6-.7.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M262.8 49.9l.7 1.7.7-.3-.7-1.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M262 47.9l.7 1.6.6-.2-.7-1.7-.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M262.662 49.565l-.702-1.658.92-.39.702 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M415.5 52.4h1.8v-.6h-1.8v.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M415.5 51.8h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M413.3 52.4h1.8v-.6h-1.8v.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M413.3 51.8h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M415.5 51.3h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M415.5 50.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M413.3 51.3h1.8v-.7h-1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M413.3 50.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M417.3 53.6h-6.4l-2.2-5.3.7-.3 2 4.8h5.9v.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M417.3 53.6h-6.4l-2.2-5.3.7-.3 2 4.8h5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M417.3 54.8h-7.2l-2.5-6 .6-.3 2.4 5.5h6.7v.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M417.3 54.8h-7.2l-2.5-6 .6-.3 2.4 5.5h6.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M412.8 52.4h-1.1l-.2-.4.5-.2.1-.1v.1h.7v.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M412.8 52.4h-1.1l-.2-.4.5-.2.1-.1v.1h.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M410.6 49.9l.7 1.7.6-.3-.7-1.7-.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M411.308 51.487l-.703-1.657.92-.39.704 1.656z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M409.7 47.8l.7 1.7.6-.3-.7-1.6-.6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M410.408 49.476l-.703-1.657.921-.39.703 1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M411.6 49.5l.7 1.6.6-.2-.7-1.7-.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M412.26 51.112l-.698-1.66.921-.387.699 1.659z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M410.7 47.4l.7 1.7.7-.3-.7-1.7-.7.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M411.474 49.024l-.702-1.657.92-.39.703 1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M452.2 52.4h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M450.4 51.7h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M454.5 52.4h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M452.7 51.7h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M452.2 51.3h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M450.4 50.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M454.5 51.3h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M452.7 50.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M450.4 53.6h6.4l2.3-5.3-.7-.3-2.1 4.8h-5.9v.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M450.4 53.6h6.4l2.3-5.3-.7-.3-2.1 4.8h-5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M450.4 54.8h7.2l2.6-6-.7-.3-2.4 5.5h-6.7v.8"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M450.4 54.8h7.2l2.6-6-.7-.3-2.4 5.5h-6.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M454.9 52.4h1.2l.2-.4-.6-.3H454.9v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M454.9 52.4h1.2l.2-.4-.6-.3H454.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M457.2 49.9l-.7 1.6-.7-.2.7-1.7.7.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M455.782 51.267l.703-1.657.92.39-.702 1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M458 47.8l-.7 1.7-.6-.3.7-1.6.6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M458 47.8l-.7 1.7-.6-.3.7-1.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M456.1 49.5l-.7 1.6-.6-.3.7-1.6.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M454.805 50.823l.699-1.659.921.389-.698 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M457 47.4l-.7 1.6-.6-.2.7-1.7.6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M455.64 48.78l.7-1.658.921.389-.7 1.658z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M391.6 249.1h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M389.8 249.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M393.8 249.1h-1.7v.7h1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M392.1 249.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M391.6 250.2h-1.8v.7h1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M389.8 250.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M393.8 250.2h-1.7v.7h1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M392.1 250.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M389.8 248h6.4l2.2 5.3-.7.3-2-4.9h-5.9v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M389.8 248h6.4l2.2 5.3-.7.3-2-4.9h-5.9z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M389.8 246.8h7.2l2.6 6-.7.3-2.4-5.6h-6.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M389.8 246.8h7.2l2.6 6-.7.3-2.4-5.6h-6.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M394.3 249.1H395.5l.2.5-.6.2H394.3v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M394.3 249.1H395.5l.2.5-.6.2H394.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M396.5 251.6l-.7-1.6-.6.3.7 1.6.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M395.837 250.017l.703 1.657-.92.39-.703-1.656z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M397.4 253.7l-.7-1.6-.6.2.7 1.7.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M396.652 252.04l.702 1.658-.921.39-.702-1.657z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M395.5 252.1l-.7-1.7-.6.3.7 1.6.6-.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M394.895 250.443l.7 1.658-.92.39-.701-1.659z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M396.4 254.1l-.7-1.6-.6.3.7 1.6.6-.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M396.4 254.1l-.7-1.6-.6.3.7 1.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M52.8 251.1v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M46.5 250.4h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M52.8 249.9v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M46.5 249.2h6.3v1h-6.3z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M51 251.5h1.8v.7H51v-.7" />
            <path stroke="#575759" strokeWidth=".1" d="M51 251.5h1.8v1H51z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M48.8 251.5h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M48.8 251.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M46.5 251.5h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M46.5 251.5h1.8v1h-1.8z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M51 252.6h1.8v.7H51v-.7" />
            <path stroke="#575759" strokeWidth=".1" d="M51 252.6h1.8v1H51z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M48.8 252.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M48.8 252.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M46.5 252.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M46.5 252.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M125.4 248.5v.8h.5v.6h-8.8v-.6h.5v-.8h-.6v-.6h8.9v.6h-.5zm-5.8.8h.8v-.8h-.8v.8zm2.2-.8h-.8v.8h.8v-.8zm1.5 0h-.8v.8h.8v-.8zm-4.4 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M123.9 248.5h1v1h-1zM118.1 248.5h1v1h-1zM122.5 248.5h1v1h-1zM121 248.5h1v1h-1zM119.6 248.5h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M125.4 248.5v.8h.5v.6H117v-.6h.5v-.8h-.5v-.7l8.9.1v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M268.2 252.2v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M261.9 251.5h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M268.2 251v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M261.9 250.3h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M266.4 252.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M266.4 252.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M264.2 252.6h1.7v.7h-1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M264.2 252.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M261.9 252.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M261.9 252.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M266.4 253.7h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M266.4 253.7h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M264.2 253.7h1.7v.7h-1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M264.2 253.7h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M261.9 253.7h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M261.9 253.7h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M262 275.6v.8h6.3v-.8H262"
            />
            <path stroke="#575759" strokeWidth=".1" d="M262 275.6h6.3v1H262z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M262 276.8v.8h6.3v-.8H262"
            />
            <path stroke="#575759" strokeWidth=".1" d="M262 276.8h6.3v1H262z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M263.8 275.2H262v-.7h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M262 274.5h1.8v1H262z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M266.1 275.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M264.3 274.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M268.3 275.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M266.5 274.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M263.8 274.1H262v-.7h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M262 273.4h1.8v1H262z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M266.1 274.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M264.3 273.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M268.3 274.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M266.5 273.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M456.2 275.5v.8h6.2v-.8h-6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.2 275.5h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M456.2 276.7v.8h6.3v-.8h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.2 276.7h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M458 275.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.2 274.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M460.2 275.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M458.4 274.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M462.5 275.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M460.7 274.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M458 274.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.2 273.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M460.2 274.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M458.4 273.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M462.5 274.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M460.7 273.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M524.4 278.7v.7h6.3v-.7h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.4 278.7h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M524.4 279.9v.7h6.3v-.7h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.4 279.9h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M526.2 278.3h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.4 277.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M528.4 278.3h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M526.6 277.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M530.7 278.3h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M528.9 277.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M526.2 277.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.4 276.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M528.4 277.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M526.6 276.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M530.7 277.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M528.9 276.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M269 248.3v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.3 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M267.6 248.3h1v1h-1zM261.8 248.3h1v1h-1zM266.1 248.3h1v1h-1zM264.6 248.3h1v1h-1zM263.2 248.3h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M269 248.3v.8h.5v.7h-8.9v-.7h.5v-.8h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M401.7 211.1v.8h.5v.6h-8.9v-.6h.5v-.8h-.5v-.6h8.9v.6h-.5zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.4-.1h-.8v.8h.8v-.8zm5 .9h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M400.2 211.1h1v1h-1zM395.2 211h-.8v.9h.8zM398.8 211.1h1v1h-1zM397.3 211.1h1v1h-1zM395.9 211h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M401.7 211.1v.8h.5v.6h-8.9v-.6h.5v-.9h-.5v-.6h8.9v.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M215.6 223.3v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.3 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M214.2 223.3h1v1h-1zM208.4 223.3h1v1h-1zM212.7 223.3h1v1h-1zM211.3 223.3h1v1h-1zM209.8 223.3h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M215.6 223.3v.8h.5v.7h-8.9v-.7h.5v-.8h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M210.9 76.9v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.3 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M209.5 76.9h1v1h-1zM203.7 76.9h1v1h-1zM208 76.9h1v1h-1zM206.6 76.9h1v1h-1zM205.1 76.9h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M210.9 76.9v.8h.5v.7h-8.9v-.7h.5v-.8h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M173.1 76.9v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.2-.8h-.8v.8h.8v-.8zm1.5 0h-.8v.8h.8v-.8zm-4.4 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M171.6 76.9h1v1h-1zM165.8 76.9h1v1h-1zM170.2 76.9h1v1h-1zM168.7 76.9h1v1h-1zM167.3 76.9h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M173.1 76.9v.8h.4v.7h-8.8v-.7h.5v-.8h-.5v-.6h8.9l-.1.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M161.7 76.9v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.3 0h-.8v.8h.8v-.8zm4.9.9h.8V77h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M160.2 76.9h1v1h-1zM154.5 76.9h1v1h-1zM158.8 76.9h1v1h-1zM157.3 76.9h1v1h-1zM155.9 76.9h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M161.7 76.9v.9h.5v.6h-8.9v-.7h.5v-.8h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M412.9 211.1v.8h.5v.6h-8.9v-.6h.5v-.8h-.5v-.6h8.9v.6h-.5zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.3 0h-.8v.8h.8v-.8zm4.9.8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M411.4 211.1h1v1h-1zM406.5 211.1h-.8l-.1.8h.9zM410 211.1h1v1h-1zM408.5 211.1h1v1h-1zM407.1 211.1h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M412.9 211.1v.8h.5v.7h-8.9v-.7h.5v-.8h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M463 210.2v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.5 0h-.8v.8h.8v-.8zm-4.4 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path stroke="#575759" strokeWidth=".1" d="M461.6 210.2h1v1h-1z" />
            <path
              stroke="#575759"
              strokeWidth=".5"
              d="M455.816 210.203l1 .007-.007 1-1-.007z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M460.1 210.2h1v1h-1zM458.7 210.2h1v1h-1zM457.2 210.2h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M463 210.2v.8h.5v.7l-8.8-.1v-.6h.5v-.8h-.5v-.6h8.8v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M474.4 210.2v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.3 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M473 210.2h1v1h-1zM468 210.2h-.8v.8h.8zM471.5 210.2h1v1h-1zM470.9 210.2h-.8v.8h.8zM468.6 210.2h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M474.4 210.2v.8h.5v.6H466v-.6h.5v-.8h-.5v-.7h8.9v.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M401.4 90v.8h.5v.6H393v-.6h.5V90h-.5v-.6h8.9v.6h-.5zm-5.8.8h.8V90h-.8v.8zm2.3-.8h-.8v.8h.8V90zm1.4 0h-.8v.8h.8V90zm-4.3 0h-.8v.8h.8V90zm4.9.8h.8V90h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M399.9 90h1v1h-1zM395 90h-.8v.8h.8zM398.5 90h1v1h-1zM397 90h1v1h-1zM395.6 90h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M401.4 90v.8h.5v.7H393v-.7h.5V90h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M387.2 151.1v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.2-.8h-.8v.8h.8v-.8zm1.5 0h-.8v.8h.8v-.8zm-4.4 0h-.8v.8h.8v-.8zm5 .9h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M385.7 151.1h1v1h-1zM380.7 151.1h-.8v.8h.8zM384.3 151.1h1v1h-1zM383.6 151.1h-.8v.9h.8zM381.4 151.1h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M387.2 151.1v.9h.4v.6h-8.8v-.7h.5v-.8h-.5v-.6h8.9l-.1.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M412.9 90v.8h.5v.6h-8.8v-.6h.5V90h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8V90h-.8v.8zm2.3-.8h-.8v.8h.8V90zm1.4 0h-.8v.8h.8V90zm-4.3 0h-.8v.8h.8V90zm5 .8h.8V90h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M411.5 90h1v1h-1zM406.5 90h-.8v.8h.8zM410 90h1v1h-1zM409.4 90h-.8v.8h.8zM407.1 90h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M412.9 90v.8h.5v.7h-8.8v-.7h.4V90h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M462.9 90v.8h.5v.6h-8.9v-.6h.5V90h-.5v-.6h8.9v.6h-.5zm-5.8.8h.8V90h-.8v.8zm2.2-.8h-.8v.8h.8V90zm1.5 0h-.8v.8h.8V90zm-4.4 0h-.8v.8h.8V90zm5 .8h.8V90h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M461.4 90h1v1h-1zM455.6 90h1v1h-1zM460 90h1v1h-1zM458.5 90h1v1h-1zM457.1 90.8h.8V90h-.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M462.9 90v.8h.5v.7h-8.9v-.7h.5V90h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M474.4 90v.8h.5v.6H466v-.6h.5V90h-.5v-.6h8.9v.6h-.5zm-5.8.8h.8V90h-.8v.8zm2.3-.8h-.8v.8h.8V90zm1.4 0h-.8v.8h.8V90zm-4.3 0h-.8v.8h.8V90zm5 .8h.8V90h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M473 90h1v1h-1zM467.2 90h1v1h-1zM471.5 90h1v1h-1zM470.1 90h1v1h-1zM468.6 90h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M474.4 90v.8h.5v.7l-8.9-.1v-.6h.5V90h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M519.8 87.9v.8h.5v.6h-8.9v-.6h.5v-.8h-.5v-.6h8.9v.6h-.5zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.5 0h-.8v.8h.8v-.8zm-4.4 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M518.4 87.9h1v1h-1zM512.6 87.9h1v1h-1zM516.9 87.9h1v1h-1zM515.5 87.9h1v1h-1zM514 87.9h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M519.8 87.9v.8h.5v.7h-8.8v-.7h.5v-.8h-.5v-.6h8.8v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M517.1 213.8v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.2-.8h-.8v.8h.8v-.8zm1.5 0h-.8v.8h.8v-.8zm-4.4 0h-.8v.8h.8v-.8zm5 .8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M515.6 213.8h1v1h-1zM509.8 213.8h1v1h-1zM515 213.8h-.8v.8h.8zM512.7 213.8h1v1h-1zM511.3 213.8h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M517.1 213.8l-.1.8h.5v.7h-8.8v-.7h.5v-.8h-.5v-.6h8.8v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M462.4 252.1v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.1 251.4h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M462.4 250.9v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.1 250.2h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M460.6 252.5h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M460.6 252.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M458.3 252.5h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M458.3 252.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M456.1 252.5h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.1 252.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M460.6 253.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M460.6 253.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M458.3 253.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M458.3 253.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M456.1 253.6h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M456.1 253.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M463.2 248.2v.8h.5v.6h-8.8v-.6h.5v-.8h-.5v-.6h8.9v.6h-.6zm-5.8.8h.8v-.8h-.8v.8zm2.3-.8h-.8v.8h.8v-.8zm1.4 0h-.8v.8h.8v-.8zm-4.3 0h-.8v.8h.8v-.8zm4.9.8h.8v-.8h-.8v.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M461.7 248.2h1v1h-1zM456 248.2h1v1h-1zM460.3 248.2h1v1h-1zM459.7 248.2h-.9v.8h.9zM457.4 248.2h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M463.2 248.2v.8h.5v.7h-8.9v-.7h.5v-.8h-.5v-.6h8.9v.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M334.4 49.6v.8h6.3v-.8h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M334.4 49.6h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M334.4 50.9v.7h6.3v-.7h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M334.4 50.9h6.3v1h-6.3z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M334.4 48.6h1.8v1h-1.8z" />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M334.4 48.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M338.4 49.3h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M336.6 48.6h1.8v1h-1.8z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M338.9 48.6h1.8v1h-1.8z" />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M338.9 48.6h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M336.2 48.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M334.4 47.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M338.4 48.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M336.6 47.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M340.7 48.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M338.9 47.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M333.6 53.5v-.8h-.5v-.6h8.9v.6h-.5v.8h.5v.6h-8.9v-.6h.5zm5.8-.8h-.8v.8h.8v-.8zm-2.3.9h.8v-.8h-.8v.8zm-1.4 0h.8v-.8h-.8v.8zm4.3 0h.8v-.8h-.8v.8zm-5-.9h-.8v.8h.8v-.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M334.2 52.7h1v1h-1zM340 52.7h1v1h-1zM335.7 52.7h1v1h-1zM337.1 52.7h1v1h-1zM338.6 52.7h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M333.6 53.5v-.8h-.5v-.6h8.9v.6h-.5v.9h.5v.6h-8.9v-.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M320.9 74.2h-.8v.5h-.6v-8.8h.6v.5h.8v-.5h.6v8.9h-.6v-.6zm-.8-5.8v.8h.8v-.8h-.8zm.8 2.3v-.8h-.8v.8h.8zm0 1.5v-.8h-.8v.8h.8zm0-4.4V67h-.8v.8h.8zm-.8 5v.8h.8v-.8h-.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M320.1 72.8h1v1h-1zM320.1 67h1v1h-1zM320.1 71.4h1v1h-1zM320.1 69.9h1v1h-1zM320.1 68.4h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M320.9 74.2h-.8v.5h-.6v-8.8h.6v.5h.8v-.5h.7v8.8h-.7z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M154.7 50.1v.8h6.2v-.8h-6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M154.7 50.1h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M154.7 51.3v.8h6.2v-.8h-6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M154.7 51.3h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M156.5 49.7h-1.8v-.6h1.8v.6"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M154.7 49.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M158.7 49.7h-1.8v-.6h1.8v.6"
            />
            <path stroke="#575759" strokeWidth=".1" d="M156.9 49h1.8v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M161 49.7h-1.8v-.6l1.8-.1v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M159.2 49.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M156.5 48.6h-1.8V48l1.8-.1v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M154.7 47.9h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M158.7 48.6h-1.8V48l1.8-.1v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M156.9 48h1.8v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M161 48.6h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M159.2 47.9h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M153.9 54v-.8h-.5v-.6h8.8v.6h-.5v.8h.5v.6h-8.9V54h.6zm5.8-.8h-.8v.8h.8v-.8zm-2.3.8h.8v-.8h-.8v.8zm-1.4 0h.8v-.8h-.8v.8zm4.3 0h.8v-.8h-.8v.8zm-5-.8h-.8v.8h.8v-.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M154.5 53.2h1v1h-1zM160.3 53.2h1v1h-1zM156 53.2h1v1h-1zM157.4 53.2h1v1h-1zM158.9 53.2h1v1h-1z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M153.9 54v-.8h-.5v-.6h8.8v.6h-.5v.8h.5v.7h-8.8V54z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M81.4 51.6v.7h6.2v-.7h-6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M81.4 51.6h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M81.4 52.8v.7h6.2v-.7h-6.2"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M81.4 52.8h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M83.2 51.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M81.4 50.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M85.4 51.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M83.6 50.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M87.7 51.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M85.9 50.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M83.2 50.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M81.4 49.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M85.4 50.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M83.6 49.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M87.7 50.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M85.9 49.4h1.8v1h-1.8z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M68 51.6v.7h6.2v-.7H68" />
            <path stroke="#575759" strokeWidth=".1" d="M68 51.6h6.2v1H68z" />
            <path fill="#FFF" fillRule="nonzero" d="M68 52.8v.7h6.2v-.7H68" />
            <path stroke="#575759" strokeWidth=".1" d="M68 52.8h6.3v1H68z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M69.7 51.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M67.9 50.5h1.8v1h-1.8z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M72 51.2h-1.8v-.7H72v.7" />
            <path stroke="#575759" strokeWidth=".1" d="M70.2 50.5H72v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M74.2 51.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M72.4 50.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M69.7 50.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M67.9 49.4h1.8v1h-1.8z"
            />
            <path fill="#FFF" fillRule="nonzero" d="M72 50.1h-1.8v-.7H72v.7" />
            <path stroke="#575759" strokeWidth=".1" d="M70.2 49.4H72v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M74.2 50.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M72.4 49.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M547.6 49.6v.7h6.3v-.8l-6.3.1"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M547.6 49.5h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M547.6 50.8v.7h6.3v-.7h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M547.6 50.8h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M549.4 49.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M547.6 48.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M551.6 49.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M549.8 48.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M553.9 49.2h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M552.1 48.5h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M549.4 48.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M547.6 47.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M551.6 48.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M549.8 47.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M553.9 48.1h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M552.1 47.4h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M599.8 51.2v.8l6.3-.1v-.7h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M599.8 51.2h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M599.8 52.4v.8h6.3v-.8h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M599.8 52.4h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M601.6 50.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M599.8 50.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M603.8 50.8H602v-.7h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M602 50.1h1.8v1H602z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M606.1 50.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M604.3 50.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M601.6 49.7h-1.8V49h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M599.8 49h1.8v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M603.8 49.7H602V49h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M602 49h1.8v1H602z" />
            <path fill="#FFF" fillRule="nonzero" d="M604.3 49h1.8v1h-1.8z" />
            <path stroke="#575759" strokeWidth=".1" d="M604.3 49h1.8v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M613.3 51.2v.7h6.3v-.7h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M613.3 51.2h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M613.3 52.4v.8h6.3v-.8h-6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M613.3 52.4h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M615.1 50.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M613.3 50.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M617.4 50.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M615.6 50.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M619.6 50.8h-1.8v-.7h1.8v.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M617.8 50.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M615.1 49.7h-1.8V49h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M613.3 49h1.8v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M617.4 49.7h-1.8V49h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M615.6 49h1.8v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M619.6 49.7h-1.8V49h1.8v.7"
            />
            <path stroke="#575759" strokeWidth=".1" d="M617.8 49h1.8v1h-1.8z" />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M546.8 53.5v-.8h-.5V52h8.8v.6h-.5v.8h.5v.6h-8.9v-.6l.6.1zm5.8-.8h-.8v.8h.8v-.8zm-2.3.8h.8v-.8h-.8v.8zm-1.4 0h.8v-.8h-.8v.8zm4.3 0h.8v-.8h-.8v.8zm-5-.8h-.8v.8h.8v-.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M547.4 52.7h1v1h-1zM553.2 52.7h1v1h-1zM548.9 52.7h1v1h-1zM550.3 52.7h1v1h-1zM552.6 52.7h-.8v.8h.8z"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M546.8 53.5v-.8h-.5V52h8.9v.7h-.5v.8h.5v.6h-8.9v-.6z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M530.5 250.7v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.2 250h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M530.5 249.5v-.8h-6.3v.8h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.2 248.7h6.3v1h-6.3z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M528.7 251.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M528.7 251.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M526.5 251.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M526.5 251.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M524.2 251.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.2 251.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M528.7 252.2h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M528.7 252.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M526.5 252.2h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M526.5 252.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M524.2 252.2h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M524.2 252.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M516.1 250.7v-.7h-6.3v.7h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M509.8 250h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M516.1 249.5v-.8h-6.3v.8h6.3"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M509.8 248.7h6.2v1h-6.2z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M514.3 251.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M514.3 251.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M512.1 251.1h1.7v.7h-1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M512.1 251.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M509.8 251.1h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M509.8 251.1h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M514.3 252.2h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M514.3 252.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M512.1 252.2h1.7v.7h-1.7v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M512.1 252.2h1.8v1h-1.8z"
            />
            <path
              fill="#FFF"
              fillRule="nonzero"
              d="M509.8 252.2h1.8v.7h-1.8v-.7"
            />
            <path
              stroke="#575759"
              strokeWidth=".1"
              d="M509.8 252.2h1.8v1h-1.8z"
            />
            <path
              fill="#3B3B3A"
              fillRule="nonzero"
              stroke="#000"
              d="M393.793 167.106l-3.677-3.677-.707.707 2.97 4.243 1.414-1.273"
            />
          </g>
          <g fillRule="nonzero">
            <path
              fill="url(#a)"
              d="M142.7 62l.2-1.3-7.2-.9c.1-.5.2-1.3.2-2.2h-5.2c0 .9.1 1.6.2 2.2h-2.5v1.3h7.2l7.1.9z"
              transform="translate(389 95)"
            />
            <path
              fill="url(#b)"
              d="M125.9 41.7h-19.5V24.2h2.4v-.7h-2.4v-7.3h2.4v-.7h-2.4V9.6h2.4v-.7h-2.4V5l2.7-1.4-.3-.6-2.3 1.2V4h-.7V.5h-.8V4h-3.3L99.8.9l-.7.4 1.7 2.7h-1.2v.1h-2.1v1h2.1v3.8h-2.1v1h2.1v7.8h-3.3v1h3.3v9.2h-3.3v1h3.3v10.8l-13.7 1.8v9.1c-.3 0-.7.1-1.1.1V46h-1l-.9 4.8c-2.1.2-4.2.3-6.5.5v-4.6h-1l-.8 4.7c-2.2.1-4.4.2-6.7.2v-4.5h-1l-.8 4.6c-2.2 0-4.5.1-6.7.1v-4.4h-1l-.8 4.4h-6.8v-4.7h-1l-.8 4.7c-2.4 0-4.6-.1-6.7-.1v-4.5h-1l-.8 4.4c-3.3-.1-6.2-.2-8.4-.4v-5h-1l-.9 4.9c-1.2-.1-2.1-.2-2.7-.3L7.4 31.1 0 39l10.9 10.9v15.6L1.7 75l6.5 6.1 19-19.3c1-.2 2.8-.3 5.2-.5v4.6h1l.8-4.7c2.4-.1 5.2-.3 8.4-.4V65h1l.8-4.2c2.2-.1 4.4-.1 6.8-.1v4.1h1l.7-4.1h6.9V65h1l.8-4.3c2.2 0 4.5 0 6.7.1v4.3h1l.8-4.3c2.3.1 4.6.2 6.8.3v4.4h1l.8-4.3c2.7.2 5.3.4 7.7.6v9.1l13.8 1.9v1.6h-2.1v1h2.1v8h-3.4v1h3.4v9.3h-3.4v1h3.4v8.1h-2.1v.7h2.1v4.2l-2.4 1.4.4.6 2-1.2v.3h1.1v3.2h.9v-3.2h3.7l1.4 2.7.6-.3-1.2-2.4h.4v-.5h2.3v-.7h-2.3v-4.1h2.3v-.7h-2.3v-7.3h2.3v-.7h-2.3V84.7h1.5v-4.5h4v-1.6h-4V71h17.9l-.6-29.3z"
              transform="translate(389 95)"
            />
            <path
              fill="url(#c)"
              d="M152 48.2L150.1 34s-4.5-2.1-9.5-1.4c-4.8.7-8 2.9-8 2.9l1.8 15 17.6-2.3z"
              transform="translate(389 95)"
            />
            <path
              fill="url(#d)"
              d="M132.6 76.5s4.1 2.6 9.1 3.2c4.9.5 8.6-1.9 8.6-1.9l1.7-14.2-17.6-2-1.8 14.9z"
              transform="translate(389 95)"
            />
            <path
              fill="url(#e)"
              d="M130.7 54.6h5.2c0-1-.1-1.9-.2-2.4l7.1-.9-.2-1.3-7.1.9h-7.2v1.3h2.6c-.1.5-.2 1.4-.2 2.4z"
              transform="translate(389 95)"
            />
            <path
              fill="url(#f)"
              d="M130.6 56.8h5.2v-1.5h-5.2v1.5z"
              transform="translate(389 95)"
            />
          </g>
          <g fillRule="nonzero">
            <path
              fill="#D8245D"
              d="M492.7 145.8l-1.3-1.4-.1-.1h-1.9c-.1 0-.2.1-.2.2v1.4h3.6s0-.1-.1-.1z"
            />
            <path
              fill="#9F214B"
              d="M492.7 146.1l-1.3 1.4-.1.1h-1.9c-.1 0-.2-.1-.2-.2V146h3.6l-.1.1z"
            />
            <path
              fill="#D8245D"
              d="M496.4 147.3v-1.9-.1l-1.4-1.4c-.1-.1-.2-.1-.2 0l-1 1 2.5 2.5c.1 0 .1-.1.1-.1z"
            />
            <path
              fill="#9F214B"
              d="M496.3 147.4h-1.9-.1l-1.4-1.4c-.1-.1-.1-.2 0-.2l1-1 2.5 2.5c0 .1-.1.1-.1.1z"
            />
            <path
              fill="#D8245D"
              d="M498 150.9l1.4-1.3.1-.1v-1.9c0-.1-.1-.2-.2-.2h-1.4v3.6c0-.1.1-.1.1-.1z"
            />
            <path
              fill="#9F214B"
              d="M497.8 150.9l-1.4-1.3-.1-.1v-1.9c0-.1.1-.2.2-.2h1.4v3.6c0-.1-.1-.1-.1-.1z"
            />
            <path
              fill="#D8245D"
              d="M496.6 154.6h2l1.4-1.4c.1-.1.1-.2 0-.2l-1-1-2.5 2.5c0 .1 0 .1.1.1z"
            />
            <path
              fill="#9F214B"
              d="M496.4 154.4v-1.9-.1l1.4-1.4c.1-.1.2-.1.2 0l1 1-2.5 2.5c-.1 0-.1 0-.1-.1z"
            />
            <g>
              <path
                fill="#D8245D"
                d="M492.9 156.2l1.3 1.4.1.1h1.9c.1 0 .2-.1.2-.2V156h-3.6c.1.1.1.1.1.2z"
              />
              <path
                fill="#9F214B"
                d="M492.9 155.9l1.3-1.4.1-.1h1.9c.1 0 .2.1.2.2v1.4h-3.6c.1 0 .1 0 .1-.1z"
              />
            </g>
            <g>
              <path
                fill="#D8245D"
                d="M489.2 154.7v2l1.4 1.4c.1.1.2.1.2 0l1-1-2.5-2.5-.1.1z"
              />
              <path
                fill="#9F214B"
                d="M489.4 154.5h2l1.4 1.4c.1.1.1.2 0 .2l-1 1-2.5-2.5.1-.1z"
              />
            </g>
            <g>
              <path
                fill="#D8245D"
                d="M487.7 151.1l-1.4 1.3-.1.1v1.9c0 .1.1.2.2.2h1.4V151c-.1 0-.1 0-.1.1z"
              />
              <path
                fill="#9F214B"
                d="M487.9 151.1l1.4 1.3.1.1v1.9c0 .1-.1.2-.2.2h-1.4V151s.1 0 .1.1z"
              />
            </g>
            <g>
              <path
                fill="#D8245D"
                d="M489.1 147.4h-1.9-.1l-1.4 1.4c-.1.1-.1.2 0 .2l1 1 2.5-2.5c0-.1 0-.1-.1-.1z"
              />
              <path
                fill="#9F214B"
                d="M489.3 147.6v2l-1.4 1.4c-.1.1-.2.1-.2 0l-1-1 2.5-2.5c.1 0 .1 0 .1.1z"
              />
            </g>
          </g>
        </g>
      </svg>
    );
  }
}
